
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1bT83", function(module, exports) {
module.exports = new URL("logo.26a63267.png", import.meta.url).toString();

});

var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$y = Array.isArray;
function $13c40c34b78c8ee2$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$g(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$x(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$x(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$P.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$P);
}
function $13c40c34b78c8ee2$var$P() {
    var n, u, t, o, r, e, c, s;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (u = $13c40c34b78c8ee2$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $13c40c34b78c8ee2$var$d({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $13c40c34b78c8ee2$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$j(c, o, s), o.__e != e && $13c40c34b78c8ee2$var$C(o)), $13c40c34b78c8ee2$var$i.length > u && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$P.__r = 0;
}
function $13c40c34b78c8ee2$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $13c40c34b78c8ee2$var$v, g = l.length;
    for(u.__d = e, $13c40c34b78c8ee2$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $13c40c34b78c8ee2$var$h : _[y.__i] || $13c40c34b78c8ee2$var$h, y.__i = a, $13c40c34b78c8ee2$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $13c40c34b78c8ee2$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $13c40c34b78c8ee2$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $13c40c34b78c8ee2$var$g(null, i, null, null, null) : $13c40c34b78c8ee2$var$y(i) ? $13c40c34b78c8ee2$var$g($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $13c40c34b78c8ee2$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $13c40c34b78c8ee2$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$x(o)), $13c40c34b78c8ee2$var$V(o, o));
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $13c40c34b78c8ee2$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$y(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$p.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$e, n.addEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$e++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $13c40c34b78c8ee2$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$d({}, h.__s)), $13c40c34b78c8ee2$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $13c40c34b78c8ee2$var$S(n, $13c40c34b78c8ee2$var$y(L = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$N(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $13c40c34b78c8ee2$var$n.call(u.childNodes), b = i.props || $13c40c34b78c8ee2$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $13c40c34b78c8ee2$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $13c40c34b78c8ee2$var$S(u, $13c40c34b78c8ee2$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $13c40c34b78c8ee2$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$13c40c34b78c8ee2$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $13c40c34b78c8ee2$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $13c40c34b78c8ee2$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$V(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$V(i[o], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$O(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$j(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$d({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$d({}, u), this.props)), n && $13c40c34b78c8ee2$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$P.__r = 0, $13c40c34b78c8ee2$var$e = 0, $13c40c34b78c8ee2$var$c = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$a = 0;


var $46eb45435212d36d$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $46eb45435212d36d$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $46eb45435212d36d$var$t = new Map;
function $46eb45435212d36d$export$2e2bcd8739ae039(s) {
    var r = $46eb45435212d36d$var$t.get(this);
    return r || (r = new Map, $46eb45435212d36d$var$t.set(this, r)), (r = $46eb45435212d36d$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $5d836d6e65da64f6$export$c0bb0b647f701bb5 = (0, $46eb45435212d36d$export$2e2bcd8739ae039).bind((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d));




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2), $204a33a7557cbbd0$var$e = $204a33a7557cbbd0$var$c.__b, $204a33a7557cbbd0$var$a = $204a33a7557cbbd0$var$c.__r, $204a33a7557cbbd0$var$v = $204a33a7557cbbd0$var$c.diffed, $204a33a7557cbbd0$var$l = $204a33a7557cbbd0$var$c.__c, $204a33a7557cbbd0$var$m = $204a33a7557cbbd0$var$c.unmount, $204a33a7557cbbd0$var$s = $204a33a7557cbbd0$var$c.__;
function $204a33a7557cbbd0$var$d(n, t) {
    $204a33a7557cbbd0$var$c.__h && $204a33a7557cbbd0$var$c.__h($204a33a7557cbbd0$var$r, n, $204a33a7557cbbd0$var$o || t), $204a33a7557cbbd0$var$o = 0;
    var u = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$D, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $204a33a7557cbbd0$var$r.u = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(n, u) {
    var i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.i = u, $204a33a7557cbbd0$var$r.__H.__h.push(i));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(n, u) {
    var i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.i = u, $204a33a7557cbbd0$var$r.__h.push(i));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(n, t) {
    $204a33a7557cbbd0$var$c.useDebugValue && $204a33a7557cbbd0$var$c.useDebugValue(t ? t(n) : n);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$j() {
    for(var n; n = $204a33a7557cbbd0$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($204a33a7557cbbd0$var$z), n.__H.__h.forEach($204a33a7557cbbd0$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $204a33a7557cbbd0$var$c.__e(t, n.__v);
    }
}
$204a33a7557cbbd0$var$c.__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, $204a33a7557cbbd0$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $204a33a7557cbbd0$var$s && $204a33a7557cbbd0$var$s(n, t);
}, $204a33a7557cbbd0$var$c.__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$z), i.__h.forEach($204a33a7557cbbd0$var$B), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, $204a33a7557cbbd0$var$c.diffed = function(n) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(t) && $204a33a7557cbbd0$var$i === $204a33a7557cbbd0$var$c.requestAnimationFrame || (($204a33a7557cbbd0$var$i = $204a33a7557cbbd0$var$c.requestAnimationFrame) || $204a33a7557cbbd0$var$w)($204a33a7557cbbd0$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, $204a33a7557cbbd0$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($204a33a7557cbbd0$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(n, t);
}, $204a33a7557cbbd0$var$c.unmount = function(n) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $204a33a7557cbbd0$var$c.__e(t, r.__v));
};
var $204a33a7557cbbd0$var$k = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$k && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$z(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$B(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}




var $044786338e0e8fe2$var$a = {};
function $044786338e0e8fe2$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $044786338e0e8fe2$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $044786338e0e8fe2$var$d(n.replace(o, "")), t = $044786338e0e8fe2$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $044786338e0e8fe2$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $044786338e0e8fe2$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $044786338e0e8fe2$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $044786338e0e8fe2$var$d(n.props.path).map($044786338e0e8fe2$var$l).join("");
    }(n), n.props;
}
function $044786338e0e8fe2$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $044786338e0e8fe2$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $044786338e0e8fe2$var$p = {}, $044786338e0e8fe2$var$m = [], $044786338e0e8fe2$var$y = [], $044786338e0e8fe2$var$U = null, $044786338e0e8fe2$var$g = {
    url: $044786338e0e8fe2$export$dc90482e4ef07afd()
}, $044786338e0e8fe2$var$k = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)($044786338e0e8fe2$var$g);
function $044786338e0e8fe2$export$9a302a45f65d0572() {
    var n = (0, $204a33a7557cbbd0$export$fae74005e78b1a27)($044786338e0e8fe2$var$k);
    if (n === $044786338e0e8fe2$var$g) {
        var t = (0, $204a33a7557cbbd0$export$60241385465d0a34)()[1];
        (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(function() {
            return $044786338e0e8fe2$var$y.push(t), function() {
                return $044786338e0e8fe2$var$y.splice($044786338e0e8fe2$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $044786338e0e8fe2$export$4cb887bfde2d34ca
    ];
}
function $044786338e0e8fe2$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.location ? $044786338e0e8fe2$var$U.location : $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.getCurrentLocation ? $044786338e0e8fe2$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $044786338e0e8fe2$var$p).pathname || "") + (n.search || "");
}
function $044786338e0e8fe2$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $044786338e0e8fe2$var$m.length; t--;)if ($044786338e0e8fe2$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U[t] ? $044786338e0e8fe2$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $044786338e0e8fe2$var$I(n);
}
function $044786338e0e8fe2$var$I(n) {
    for(var t = !1, r = 0; r < $044786338e0e8fe2$var$m.length; r++)$044786338e0e8fe2$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $044786338e0e8fe2$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $044786338e0e8fe2$export$4cb887bfde2d34ca(t);
    }
}
function $044786338e0e8fe2$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $044786338e0e8fe2$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($044786338e0e8fe2$var$M(t)) return $044786338e0e8fe2$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $044786338e0e8fe2$var$w = !1;
function $044786338e0e8fe2$export$55185c17a0fcbe46(n) {
    n.history && ($044786338e0e8fe2$var$U = n.history), this.state = {
        url: n.url || $044786338e0e8fe2$export$dc90482e4ef07afd()
    };
}
$044786338e0e8fe2$var$c($044786338e0e8fe2$export$55185c17a0fcbe46.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $044786338e0e8fe2$var$w || ($044786338e0e8fe2$var$w = !0, $044786338e0e8fe2$var$U || addEventListener("popstate", function() {
            $044786338e0e8fe2$var$I($044786338e0e8fe2$export$dc90482e4ef07afd());
        }), addEventListener("click", $044786338e0e8fe2$var$W)), $044786338e0e8fe2$var$m.push(this), $044786338e0e8fe2$var$U && (this.u = $044786338e0e8fe2$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $044786338e0e8fe2$var$m.splice($044786338e0e8fe2$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($044786338e0e8fe2$var$v).sort($044786338e0e8fe2$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $044786338e0e8fe2$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n.children), a);
        if (h && (u = (0, $13c40c34b78c8ee2$export$e530037191fcd5d7)(h[0], $044786338e0e8fe2$var$c($044786338e0e8fe2$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $044786338e0e8fe2$var$c($044786338e0e8fe2$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $044786338e0e8fe2$var$y.length; v--;)$044786338e0e8fe2$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($044786338e0e8fe2$var$k.Provider, {
            value: s
        }, u);
    }
});
var $044786338e0e8fe2$export$a6c7ac8248d6e38a = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", $044786338e0e8fe2$var$c({
        onClick: $044786338e0e8fe2$var$W
    }, n));
}, $044786338e0e8fe2$export$e7b0ac011bb776c6 = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(n.component, n);
};


/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $33893b708b33402d$var$isArray(value) {
    return !Array.isArray ? $33893b708b33402d$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $33893b708b33402d$var$INFINITY = 1 / 0;
function $33893b708b33402d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$33893b708b33402d$var$INFINITY ? "-0" : result;
}
function $33893b708b33402d$var$toString(value) {
    return value == null ? "" : $33893b708b33402d$var$baseToString(value);
}
function $33893b708b33402d$var$isString(value) {
    return typeof value === "string";
}
function $33893b708b33402d$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $33893b708b33402d$var$isBoolean(value) {
    return value === true || value === false || $33893b708b33402d$var$isObjectLike(value) && $33893b708b33402d$var$getTag(value) == "[object Boolean]";
}
function $33893b708b33402d$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $33893b708b33402d$var$isObjectLike(value) {
    return $33893b708b33402d$var$isObject(value) && value !== null;
}
function $33893b708b33402d$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $33893b708b33402d$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $33893b708b33402d$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $33893b708b33402d$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $33893b708b33402d$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $33893b708b33402d$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $33893b708b33402d$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $33893b708b33402d$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $33893b708b33402d$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $33893b708b33402d$var$hasOwn = Object.prototype.hasOwnProperty;
class $33893b708b33402d$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $33893b708b33402d$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $33893b708b33402d$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($33893b708b33402d$var$isString(key) || $33893b708b33402d$var$isArray(key)) {
        src = key;
        path = $33893b708b33402d$var$createKeyPath(key);
        id = $33893b708b33402d$var$createKeyId(key);
    } else {
        if (!$33893b708b33402d$var$hasOwn.call(key, "name")) throw new Error($33893b708b33402d$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($33893b708b33402d$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($33893b708b33402d$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $33893b708b33402d$var$createKeyPath(name);
        id = $33893b708b33402d$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $33893b708b33402d$var$createKeyPath(key) {
    return $33893b708b33402d$var$isArray(key) ? key : key.split(".");
}
function $33893b708b33402d$var$createKeyId(key) {
    return $33893b708b33402d$var$isArray(key) ? key.join(".") : key;
}
function $33893b708b33402d$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$33893b708b33402d$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$33893b708b33402d$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($33893b708b33402d$var$isString(value) || $33893b708b33402d$var$isNumber(value) || $33893b708b33402d$var$isBoolean(value))) list.push($33893b708b33402d$var$toString(value));
            else if ($33893b708b33402d$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $33893b708b33402d$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $33893b708b33402d$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $33893b708b33402d$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $33893b708b33402d$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $33893b708b33402d$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $33893b708b33402d$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $33893b708b33402d$var$Config = {
    ...$33893b708b33402d$var$BasicOptions,
    ...$33893b708b33402d$var$MatchOptions,
    ...$33893b708b33402d$var$FuzzyOptions,
    ...$33893b708b33402d$var$AdvancedOptions
};
const $33893b708b33402d$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $33893b708b33402d$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($33893b708b33402d$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $33893b708b33402d$var$FuseIndex {
    constructor({ getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}){
        this.norm = $33893b708b33402d$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($33893b708b33402d$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($33893b708b33402d$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$33893b708b33402d$var$isDefined(doc) || $33893b708b33402d$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$33893b708b33402d$var$isDefined(value)) return;
            if ($33893b708b33402d$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$33893b708b33402d$var$isDefined(value)) continue;
                    if ($33893b708b33402d$var$isString(value) && !$33893b708b33402d$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($33893b708b33402d$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($33893b708b33402d$var$isString(value) && !$33893b708b33402d$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $33893b708b33402d$var$createIndex(keys, docs, { getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $33893b708b33402d$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($33893b708b33402d$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $33893b708b33402d$var$parseIndex(data, { getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $33893b708b33402d$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $33893b708b33402d$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $33893b708b33402d$var$Config.distance, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $33893b708b33402d$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $33893b708b33402d$var$MAX_BITS = 32;
function $33893b708b33402d$var$search(text, pattern, patternAlphabet, { location: location = $33893b708b33402d$var$Config.location, distance: distance = $33893b708b33402d$var$Config.distance, threshold: threshold = $33893b708b33402d$var$Config.threshold, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $33893b708b33402d$var$MAX_BITS) throw new Error($33893b708b33402d$var$PATTERN_LENGTH_TOO_LARGE($33893b708b33402d$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $33893b708b33402d$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $33893b708b33402d$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $33893b708b33402d$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $33893b708b33402d$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $33893b708b33402d$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $33893b708b33402d$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $33893b708b33402d$var$BitapSearch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $33893b708b33402d$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $33893b708b33402d$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $33893b708b33402d$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $33893b708b33402d$var$MAX_BITS), i);
                i += $33893b708b33402d$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $33893b708b33402d$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $33893b708b33402d$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $33893b708b33402d$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $33893b708b33402d$var$ExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $33893b708b33402d$var$InverseExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $33893b708b33402d$var$PrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $33893b708b33402d$var$InversePrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $33893b708b33402d$var$SuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $33893b708b33402d$var$InverseSuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $33893b708b33402d$var$FuzzyMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $33893b708b33402d$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $33893b708b33402d$var$IncludeMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $33893b708b33402d$var$searchers = [
    $33893b708b33402d$var$ExactMatch,
    $33893b708b33402d$var$IncludeMatch,
    $33893b708b33402d$var$PrefixExactMatch,
    $33893b708b33402d$var$InversePrefixExactMatch,
    $33893b708b33402d$var$InverseSuffixExactMatch,
    $33893b708b33402d$var$SuffixExactMatch,
    $33893b708b33402d$var$InverseExactMatch,
    $33893b708b33402d$var$FuzzyMatch
];
const $33893b708b33402d$var$searchersLen = $33893b708b33402d$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $33893b708b33402d$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $33893b708b33402d$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $33893b708b33402d$var$parseQuery(pattern, options = {}) {
    return pattern.split($33893b708b33402d$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($33893b708b33402d$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $33893b708b33402d$var$MultiMatchSet = new Set([
    $33893b708b33402d$var$FuzzyMatch.type,
    $33893b708b33402d$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $33893b708b33402d$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $33893b708b33402d$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($33893b708b33402d$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $33893b708b33402d$var$registeredSearchers = [];
function $33893b708b33402d$var$register(...args) {
    $33893b708b33402d$var$registeredSearchers.push(...args);
}
function $33893b708b33402d$var$createSearcher(pattern, options) {
    for(let i = 0, len = $33893b708b33402d$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $33893b708b33402d$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $33893b708b33402d$var$BitapSearch(pattern, options);
}
const $33893b708b33402d$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $33893b708b33402d$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $33893b708b33402d$var$isExpression = (query)=>!!(query[$33893b708b33402d$var$LogicalOperator.AND] || query[$33893b708b33402d$var$LogicalOperator.OR]);
const $33893b708b33402d$var$isPath = (query)=>!!query[$33893b708b33402d$var$KeyType.PATH];
const $33893b708b33402d$var$isLeaf = (query)=>!$33893b708b33402d$var$isArray(query) && $33893b708b33402d$var$isObject(query) && !$33893b708b33402d$var$isExpression(query);
const $33893b708b33402d$var$convertToExplicit = (query)=>({
        [$33893b708b33402d$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $33893b708b33402d$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $33893b708b33402d$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$33893b708b33402d$var$isExpression(query)) return next($33893b708b33402d$var$convertToExplicit(query));
        if ($33893b708b33402d$var$isLeaf(query)) {
            const key = isQueryPath ? query[$33893b708b33402d$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$33893b708b33402d$var$KeyType.PATTERN] : query[key];
            if (!$33893b708b33402d$var$isString(pattern)) throw new Error($33893b708b33402d$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $33893b708b33402d$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $33893b708b33402d$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($33893b708b33402d$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$33893b708b33402d$var$isExpression(query)) query = $33893b708b33402d$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $33893b708b33402d$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $33893b708b33402d$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $33893b708b33402d$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$33893b708b33402d$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$33893b708b33402d$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $33893b708b33402d$var$transformScore(result, data) {
    data.score = result.score;
}
function $33893b708b33402d$var$format(results, docs, { includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, includeScore: includeScore = $33893b708b33402d$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($33893b708b33402d$var$transformMatches);
    if (includeScore) transformers.push($33893b708b33402d$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $33893b708b33402d$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$33893b708b33402d$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $33893b708b33402d$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $33893b708b33402d$var$FuseIndex)) throw new Error($33893b708b33402d$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $33893b708b33402d$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$33893b708b33402d$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $33893b708b33402d$var$isString(query) ? $33893b708b33402d$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $33893b708b33402d$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($33893b708b33402d$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $33893b708b33402d$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $33893b708b33402d$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$33893b708b33402d$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $33893b708b33402d$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $33893b708b33402d$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($33893b708b33402d$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $33893b708b33402d$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$33893b708b33402d$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$33893b708b33402d$var$isDefined(value)) return [];
        let matches = [];
        if ($33893b708b33402d$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$33893b708b33402d$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$33893b708b33402d$export$2e2bcd8739ae039.version = "6.6.2";
$33893b708b33402d$export$2e2bcd8739ae039.createIndex = $33893b708b33402d$var$createIndex;
$33893b708b33402d$export$2e2bcd8739ae039.parseIndex = $33893b708b33402d$var$parseIndex;
$33893b708b33402d$export$2e2bcd8739ae039.config = $33893b708b33402d$var$Config;
$33893b708b33402d$export$2e2bcd8739ae039.parseQuery = $33893b708b33402d$var$parse;
$33893b708b33402d$var$register($33893b708b33402d$var$ExtendedSearch);


var $ec47c5424ac040c3$exports = {};
$ec47c5424ac040c3$exports = "﻿Supplier ID,Supplier Part ID,Item Description,Unit Price,Unit of Measure,Short Name,Classification Codes-1 TYPE,Classification Codes-1,,Image-1,Image-2,PunchOut Enabled,PunchoutLevel,Keywords,Supplier URL,Lead Time,Effective Date,Expiration Date,hazardousmaterials,green,Supplier Part Auxiliary ID,Language,Classification Codes-2 Type,Classification Codes-2\nAN01060825151,01245,\"ACIDO CLORHIDRICO A.C.S., PRESENTACION 2.5 L, FERMONT\",947.00,H87,\"ACIDO CLORHIDRICO A.C.S., PRESENTACION 2.5 L, FERMONT\",UNSPSC,32169090,,01245,01245,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2181,\"REMOVEDOR DE ADHESIVO, GOO GONE, 16OZ\",382.00,H87,\"REMOVEDOR DE ADHESIVO, GOO GONE, 16OZ\",UNSPSC,32039090,,2181,2181,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,4020,\"SOLVAC FILTER HOLDER, MATERIALES DE CONSTRUCCIÓN: CARCASA SUPERIOR, BASE DE LA CARCASA: POLIPROPILENO ,TUBERÍA DE LÍNEA DE ALIM ENTACIÓN: TYGON * ULTRA RESISTENTE A PRODUCTOS QUÍMICOS, 4.8 mm (3/16 IN.) ID, ABRAZADERA DE PULGAR: CELCON *PLOMO DE LÍNEA DE ALIM ENTACIÓN: PTFE, ADAPTADOR DE PUERTO DE VACÍO, JUNTA DE SELLO DE MEMBRANA Y JUNTA DE SELLO: POLIETILENO. ACEPTA FILTROS DE 47MM DE DIÁMETRO DE \",27316.00,H87,\"SOLVAC FILTER HOLDER, MATERIALES DE CONSTRUCCIÓN: CARCASA SUPERIOR, BASE DE LA C\",UNSPSC,32039090,,4020,4020,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,4021,\"PIPETA SEROLÓGICAS STRIPETTE ™  DE 2 ML, ENVUELTAS EN PLÁSTICO INDIVIDUALMENTE, ESTÉRILES, BANDA VERDE CJ/1000 CORNING\",10058.00,BX,\"PIPETA SEROLÓGICAS STRIPETTE ™  DE 2 ML, ENVUELTAS EN PLÁSTICO INDIVIDUALMENTE, \",UNSPSC,32039090,,4021,4021,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,4051,\"PIPETA SEROLÓGICAS STRIPETTE ™  5 ML POLIESTIRENO, ENVUELTAS EN PLÁSTICO INDIVIDUALMENTE, ESTÉRILES,  BANDA AZUL, CJ/200 PZAS CORNING\",3883.00,BX,\"PIPETA SEROLÓGICAS STRIPETTE ™  5 ML POLIESTIRENO, ENVUELTAS EN PLÁSTICO INDIVID\",UNSPSC,32039090,,4051,4051,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,4101,\"PIPETAS SEROLÓGICAS STRIPETTE DE 10 ML, POLIESTIRENO, ENVUELTAS EN PLÁSTICO INDIVIDUALMENTE, ESTPERILES, CON BANDA NARANJA  CJ/200, CORNING\",2612.00,BX,\"PIPETAS SEROLÓGICAS STRIPETTE DE 10 ML, POLIESTIRENO, ENVUELTAS EN PLÁSTICO INDI\",UNSPSC,32039090,,4101,4101,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,9810.08,\"CONTENEDOR PARA LA ELIMINACIÓN SEGURA DE CUCHILLAS USADAS. DIMENSIONES: 3.75 \"\"L X 3.75\"\" W X 7.625 \"\"H, MARTOR\",3061.00,H87,\"CONTENEDOR PARA LA ELIMINACIÓN SEGURA DE CUCHILLAS USADAS. DIMENSIONES: 3.75 \"\"L \",UNSPSC,32039090,,9810.08,9810.08,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,13913,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 10:0,02 ML, BORO 3.3, FRANJA SCHELLBACH, DIN EN ISO 385, BRAND\",2142.51,H87,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 10:0,02 ML, BORO 3.3, FRANJA SCHELLBACH, \",UNSPSC,32039090,,13913,13913,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,13916,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 25:0,05 ML, BORO 3.3, FRANJA SCHELLBACH,DIN EN ISO 385, BRAND\",2142.51,H87,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 25:0,05 ML, BORO 3.3, FRANJA SCHELLBACH,D\",UNSPSC,32039090,,13916,13916,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,13918,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 50:0,1  ML, BORO 3.3, FRANJA SCHELLBACH, BRAND\",2142.51,H87,\"BURETA COMPACTA LLAVE PTFE BB AS DE-M, 50:0,1  ML, BORO 3.3, FRANJA SCHELLBACH, \",UNSPSC,32039090,,13918,13918,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,29702,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 1 ML, 1 AFORO, AR-GLAS, BRAND CAJA C 12 PZ\",2916.00,BX,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 1 ML, 1 AFORO, AR-GLAS, BRAND CAJA C 12 PZ\",UNSPSC,32039090,,29702,29702,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,29703,\"PIPETA AFORADA BLAUBRAND CL. AS DE-M 2 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/12 PZ\",3009.00,BX,\"PIPETA AFORADA BLAUBRAND CL. AS DE-M 2 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/12 PZ\",UNSPSC,32039090,,29703,29703,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,29707,\"PIPETA AFORADA BLAUBRAND CL. AS DE-M 5 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",1778.00,BX,\"PIPETA AFORADA BLAUBRAND CL. AS DE-M 5 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",UNSPSC,32039090,,29707,29707,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,29713,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 15 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",2719.00,BX,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 15 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",UNSPSC,32039090,,29713,29713,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,29714,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 20 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",2691.00,BX,\"PIPETA AFORADA, BLAUBRAND CL. AS DE-M 20 ML, 1 AFORO, AR-GLAS, BRAND CAJA C/6 PZ\",UNSPSC,32039090,,29714,29714,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,30607,\"PIPETA AFOR. BLAUBRAND CL. AS USP DE-M 5 ML, 1 AFORO, AR-GLAS, CAJA C/6 PZ, BRAND\",2791.00,BX,\"PIPETA AFOR. BLAUBRAND CL. AS USP DE-M 5 ML, 1 AFORO, AR-GLAS, CAJA C/6 PZ, BRAN\",UNSPSC,32039090,,30607,30607,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,32128,\"PROBETA GRADUADA ALTA BLAUBRAND A DE-M 50 ML: 1 ML, BORO 3.3, CAJA C/2 PZ BRAND\",1343.00,BX,\"PROBETA GRADUADA ALTA BLAUBRAND A DE-M 50 ML: 1 ML, BORO 3.3, CAJA C/2 PZ BRAND\",UNSPSC,25070490,,32128,32128,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,32838,\"PROBETA GRADUADA ALTA BLAUBRAND A DE-M,  100 ml: 1   ml, BORO 3.3, GRA. AZUL, CON PICO Y PIE HEXAGONAL, MARCA ANULAR EN LOS PUNTOS PRINCIPALES, DIN EN ISO 4788, CON CERTIFICADO DE LOTE USP\",1607.00,H87,\"PROBETA GRADUADA ALTA BLAUBRAND A DE-M,  100 ml: 1   ml, BORO 3.3, GRA. AZUL, CO\",UNSPSC,32039090,,32838,32838,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,36402,\"MATRAZ AFORADO TRAPEZ. BLAUBRAND A DE-M 2 ML, BORO 3.3 NS 7/16  GRAD AZÚÑ, TAPÓN EN PP, CAJA C/2 PZ, BRAND\",1471.00,BX,\"MATRAZ AFORADO TRAPEZ. BLAUBRAND A DE-M 2 ML, BORO 3.3 NS 7/16  GRAD AZÚÑ, TAPÓN\",UNSPSC,32039090,,36402,36402,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37238,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 5 ML A, BORO 3.3 NS 10/19 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",1548.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 5 ML A, BORO 3.3 NS 10/19 TAPÓN EN PP,  CA\",UNSPSC,32039090,,37238,37238,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37243,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 10 ML A, BORO 3.3 NS 10/19 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",1333.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 10 ML A, BORO 3.3 NS 10/19 TAPÓN EN PP,  C\",UNSPSC,32039090,,37243,37243,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37245,\"MATRAZ AFORADO, BLAUBRAND, CL. A, DE-M 20 ML A, BORO 3.3,  NS 10/19 , GRAD. AZÚL, DIN EN ISO 1042  CAJA C/2 PZ, BRAND\",3307.00,BX,\"MATRAZ AFORADO, BLAUBRAND, CL. A, DE-M 20 ML A, BORO 3.3,  NS 10/19 , GRAD. AZÚL\",UNSPSC,32039090,,37245,37245,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37250,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 200 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",1824.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 200 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CA\",UNSPSC,32039090,,37250,37250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37251,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 250 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",3299.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 250 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CA\",UNSPSC,32039090,,37251,37251,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37252,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 500 ML, BORO 3.3 NS 19/26 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",2224.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 500 ML, BORO 3.3 NS 19/26 TAPÓN EN PP,  CA\",UNSPSC,32039090,,37252,37252,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37253,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 1000 ML, BORO 3.3 NS 24/29 TAPÓN EN PP,  BRAND\",2055.00,H87,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 1000 ML, BORO 3.3 NS 24/29 TAPÓN EN PP,  B\",UNSPSC,32039090,,37253,37253,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37290,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 50 ML A, BORO 3.3 NS 14/23 CUELLO ANCHO,M GRAD. AZÚL, DIN EN ISO 1042, CJ/2, TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",978.25,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 50 ML A, BORO 3.3 NS 14/23 CUELLO ANCHO,M \",UNSPSC,32039090,,37290,37290,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37291,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 100 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",1578.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 100 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CA\",UNSPSC,32039090,,37291,37291,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37293,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 25 ML A, BORO 3.3 NS 12/21 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",1584.00,BX,\"MATRAZ AFORADO BLAUBRAND CLASE A DE-M 25 ML A, BORO 3.3 NS 12/21 TAPÓN EN PP,  C\",UNSPSC,32039090,,37293,37293,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37403,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 20 ML, BORO 3.3 NS 10/19 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",2646.00,BX,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 20 ML, BORO 3.3 NS 10/19 TAPÓN EN PP,  C\",UNSPSC,32039090,,37403,37403,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37404,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 25 ML, BORO 3.3 NS 10/19 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",2646.00,BX,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 25 ML, BORO 3.3 NS 10/19 TAPÓN EN PP,  C\",UNSPSC,32039090,,37404,37404,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37406,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 50 ML A, BORO 3.3 NS 14/23 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",2807.00,BX,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 50 ML A, BORO 3.3 NS 14/23 TAPÓN EN PP, \",UNSPSC,32039090,,37406,37406,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37407,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 100 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  CAJA C/2 PZ, BRAND\",2808.00,BX,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 100 ML, BORO 3.3 NS 14/23 TAPÓN EN PP,  \",UNSPSC,32039090,,37407,37407,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,60110,\"CRISOL DE PORCELANA CAPACIDAD DE 100 mL, FORMA ALTA. COORSTEK\",2231.00,H87,\"CRISOL DE PORCELANA CAPACIDAD DE 100 mL, FORMA ALTA. COORSTEK\",UNSPSC,32039090,,60110,60110,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,85199,\"MANVER 2 PWD PLWS 50ML PK/100, HACH\",2045.00,XPK,\"MANVER 2 PWD PLWS 50ML PK/100, HACH\",UNSPSC,32169090,,85199,85199,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,111729,\"SOLUCIÓN ESTÁNDAR SILICA, 50 mg/L as SiO2 (NIST), 200 mL, HACH\",2858.00,H87,\"SOLUCIÓN ESTÁNDAR SILICA, 50 mg/L as SiO2 (NIST), 200 mL, HACH\",UNSPSC,32169090,,111729,111729,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,210700,AGAR DEXTROSA SABORAUD 450 G BD ,1877.00,H87,AGAR DEXTROSA SABORAUD 450 G,UNSPSC,32039090,,210700,210700,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,214600,\"AGAR SAL Y MANITOL BX, 450G, BD BIOXON®\",2328.00,H87,\"AGAR SAL Y MANITOL BX, 450G, BD BIOXON®\",UNSPSC,32039090,,214600,214600,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,218263,BOTTLE R2A AGAR 500G DIFCO ,4858.00,H87,BOTTLE R2A AGAR 500G,UNSPSC,32039090,,218263,218263,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,218581,BOTTLE RAPPAPORT VASSILIDAS R10 BR 500G DIFCO,3737.00,H87,BOTTLE RAPPAPORT VASSILIDAS R10 BR 500G,UNSPSC,32039090,,218581,218581,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,231430,\"MEDIO EC, DEHIDRATADO 500 G, BD DIFCO™\",3536.00,H87,\"MEDIO EC, 500 G, BD DIFCO™\",UNSPSC,32039090,,231430,231430,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,238230,BOTTLE SABOURAUD DEXTROSE BROTH 500G,4125.00,H87,BOTTLE SABOURAUD DEXTROSE BROTH 500G,UNSPSC,32039090,,238230,238230,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,263010,CALDO LETHEEN MODIFICADO (AOAC) 500GR - DIFCO,5696.00,H87,CALDO LETHEEN MODIFICADO (AOAC) 500GR - DIFCO,UNSPSC,32039090,,263010,263010,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,274000,\"BOTTLE BRILLIANT GREEN BILE 2%, PRESENTCAION  500G BD DIFCO\",4905.00,H87,BOTTLE BRILLIANT GREEN BILE 2% 500G,UNSPSC,32039090,,274000,274000,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,278850,BOTTLE XLD AGAR PRESENTACION 500G BD DIFCO ,3953.00,H87,BOTTLE XLD AGAR 500G,UNSPSC,32039090,,278850,278850,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,442941,\"JARRA GRADUADA DE PP, ESCALA EN RELIEVE, 1000ML, VITLAB\",644.00,H87,\"JARRA GRADUADA DE PP, ESCALA EN RELIEVE, 1000ML, VITLAB\",UNSPSC,32039090,,442941,442941,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,443941,\"JARRA GRADUADA, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIEVE , CAPACIDAD 2000 mL, DIVISIÓN NOMINAL 20 ML, DIAMETRO 152mm, ALTURA 213 mm.\",1301.00,H87,\"JARRAS GRADUADAS, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIE\",UNSPSC,32039090,,443941,443941,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,444941,\"JARRA GRADUADA, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIEVE , CAPACIDAD 3000 mL, DIVISIÓN NOMINAL 50 ML, DIAMETRO 172 mm, ALTURA 242 mm.\",1793.00,H87,\"JARRAS GRADUADAS, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIE\",UNSPSC,32039090,,444941,444941,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,705211,\"HANDYSTEP TOUCH S SOPORTE DE CARGA INCL. FUENTE ALIM.UNIVERSAL/SOPORTE UNIVERSAL 3481, LITHIUM ION BATTERIES IN EQUIPMENT, 9, (E) 29 g PER BATTERY ,BRAND\",60059.00,H87,HANDYSTEP TOUCH S SOPORTE DE CARGA INCL. FUENTE ALIM.UNIVERSAL/SOPORTE UNIVERSAL,UNSPSC,32032903,,705211,705211,True,,,,30,01/01/2026,12/12/2027,,,,es_MX,eclass,32032903\nAN01060825151,1001110,PAPEL FILTRO # 1 DE 11.0 CM CAJA C/ 100 WHATMAN,2566.00,BX,PAPEL FILTRO # 1 DE 11.0 CM CAJA C/ 100,UNSPSC,32039090,,1001110,1001110,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,2106269,\"REACTIVO ACIDO CITRICO BOLSA C/100, HACH\",2333.00,XPK,REACTIVO ACIDO CITRICO C/100,UNSPSC,25070490,,2106269,2106269,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,2107369,\"REACTIVO P/MOLIBDATO PB.DE 10 ML. BOLSA. C/100, HACH\",2754.00,XPK,REACTIVO P/MOLIBDATO PB.DE 10 ML. PQ. C/100 ,UNSPSC,32169090,,2107369,2107369,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2229726,\"EGTA SOLUTION 50ML SCDB, MARCA HACH\",2884.00,H87,\"EGTA SOLUTION 50ML SCDB, MARCA HACH\",UNSPSC,32169090,,2229726,2229726,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2241732,\"ALKALI SOLUTION 100ML MDB, HACH\",2045.00,H87,\"ALKALI SOLUTION 100ML MDB, HACH\",UNSPSC,32169090,,2241732,2241732,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2241832,\"CALCIUM/MAGNESIUM IND 100ML MDB, HACH\",2255.00,H87,\"CALCIUM/MAGNESIUM IND 100ML MDB, HACH\",UNSPSC,32169090,,2241832,2241832,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2297255,\"POLVO INDICADOR DPD, LIBRE + TOTAL, 24 G, HACH\",2333.00,H87,\"POLVO INDICADOR DPD, LIBRE + TOTAL, 24 G, HACH\",UNSPSC,32169090,,2297255,2297255,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2314011,\"SOLUCION INDICADORA LIBRE DE CLORO 473ML, HACH \",2464.00,H87,SOLUCION INDICADORA LIBRE DE CLORO 473ML,UNSPSC,32169090,,2314011,2314011,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2314111,\"SOLUCIÓN TAMPÓN DE CLORO LIBRE PARA EL ANALIZADOR DE CLORO CL17, 473 ML, HACH\",2255.00,H87,\"SOLUCIÓN TAMPÓN DE CLORO LIBRE PARA EL ANALIZADOR DE CLORO CL17, 473 ML, HACH\",UNSPSC,32169090,,2314111,2314111,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2429600,\"JUEGO DE REACTIVOS P/SILICA RANGO ALTO (BOLSA C/100 PRUEBAS), HACH\",6595.00,XPK,JUEGO DE REACTIVOS P/SILICA RANGO ALTO (100 PRUEBAS),UNSPSC,32169090,,2429600,2429600,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,6400812,\"CARTUCHOS DRÄGER FLOW CHECK CAJA CON 3 PIEZAS, DRAEGER\",2688.00,BX,CARTUCHOS DRÄGER FLOW CHECK CAJA CON 3 PIEZAS,UNSPSC,32039090,,6400812,6400812,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,6728371,\"TUBO COLORIMÉTRICO PARA LA DETECCIÓN DE ACEITE 10/a-P CON RANGO DE MEDICIÓN DE 0,1 A 1 mg/m3 MARCA DRÄGER CAJA c/ 10 PZ, DRAEGER\",5038.00,BX,TUBO COLORIMÉTRICO PARA LA DETECCIÓN DE ACEITE 10/a-P CON RANGO DE MEDICIÓN DE 0,UNSPSC,32039090,,6728371,6728371,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,6728511,\"TUBO COLORIMETRICO PARA LA DETECCIÓN DE MONOXIDO DE CARBONO CAJA CON 10 PIEZAS, DRAGER\",4661.00,BX,TUBO COLORIMETRICO PARA LA DETECCIÓN DE MONOXIDO DE CARBONO CAJA CON 10 PIEZAS ,UNSPSC,32039090,,6728511,6728511,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,6728521,\"TUBO COLORIMETRICO PARA LA DETECCION DE DIOXIDO DE CARBONO CAJA CON 10 PIEZAS, DRAEGER\",4724.00,BX,TUBO COLORIMETRICO PARA LA DETECCION DE DIOXIDO DE CARBONO CAJA CON 10 PIEZAS,UNSPSC,32039090,,6728521,6728521,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,008931182,LIMPIADOR BMF 4 5L WÜRTH,2937.00,H87,LIMPIADOR BMF 4 5L WÜRTH,UNSPSC,32039090,,008931182,008931182,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,10463052,\"FILTRO DE JERINGA SPARTAN HPLC RC 30 MM 0.45 UM L, CAJA CON 500 PZ , WHATMAN\",67326.00,BX,\"FILTRO DE JERINGA SPARTAN HPLC RC 30 MM 0.45 UM L, CAJA CON 500 PZ \",UNSPSC,32039090,,10463052,10463052,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,10463800,\"ROBY AUTOMATED FILTER 25 MM, GLASS  FIBER PRE-FILTER GF92, PORE SIZE 1, CYTIVA/WHATMAN® , PAQ/1000 \",141452.00,XPK,\"ROBY AUTOMATED FILTER 25 MM, GLASS \",UNSPSC,32039090,,10463800,10463800,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030073479,PUNTA P/PIPETA DE 50 A 1000 ul. CJ. C/960  MARCA EPPENDOR,4838.00,BX,PUNTA P/PIPETA DE 50 A 1000 ul. CJ. C/960  MARCA EPPENDOR,UNSPSC,20270110,,0030073479,0030073479,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,48112430,\"BATERÍA COMPACTA REDLITHIUM 3.0 M12, MARCA MILWAUKEE\",2491.00,H87,\"BATERÍA COMPACTA REDLITHIUM 3.0 M12, MARCA MILWAUKEE\",UNSPSC,32039090,,48112430,48112430,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,150331000,\"THYMOL, 100G, ACROS ORGANICS  \",6458.00,H87,\"THYMOL, 100G, ACROS ORGANICS  \",UNSPSC,32039090,,150331000,150331000,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,218011753,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA IN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 32, 50 ML ,DURAN, CAJA CON 10 PIEZAS.\",2214.00,BX,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA IN, GRADUADOS, CON TAPA A ROSCA Y ANIL\",UNSPSC,32169090,,218011753,218011753,True,,,,180,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,218013651,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 45, 250 ML ,DURAN, CAJA CON 10 PIEZAS \",2834.00,BX,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y AN\",UNSPSC,25070490,,218013651,218013651,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,218014459,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 45, 500 ML, CAJA CON 10 PZS , DURAN\",2138.00,BX,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y ANI\",UNSPSC,32039090,,218014459,218014459,True,,,,25,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,218015455,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA IN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 45, 1000 ML, CAJA CON 10 PZS, DURAN.\",3173.00,BX,\"DURAN® FRASCOS PARA LABORATORIO CON ROSCA IN, GRADUADOS, CON TAPA A ROSCA Y ANIL\",UNSPSC,25070490,,218015455,218015455,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,218016357,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 45, 2000 ML ,DURAN, CAJA CON 10 PIEZAS \",6845.00,BX,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y AN\",UNSPSC,25070490,,218016357,218016357,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,218033653,\" DURAN® MATRACES ERLENMEYER CON ROSCA DIN, GRADUADOS, CON TAPA DE PLÁSTICO, GL 32, 250 ML ,DURAN, CAJA CON 10 PIEZAS \",10853.00,BX,\" DURAN® MATRACES ERLENMEYER CON ROSCA DIN, GRADUADOS, CON TAPA DE PLÁSTICO, GL 3\",UNSPSC,40019090,,218033653,218033653,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,40019090\nAN01060825151,8300027529,\" NORM-JECT® LUER-LOCK AND LUER-SLIP BULK SYRINGES, 20mL,TWO-PART, NONSTERILE, AIR-TITE, CJA CON 10 BOLSAS  (BOLSA DE 100 C/U)\",15894.00,BX,\" NORM-JECT® LUER-LOCK AND LUER-SLIP BULK SYRINGES, 20mL,TWO-PART, NONSTERILE, AI\",UNSPSC,32039090,,8300027529,8300027529,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#0,\"ESCOBILLON PARATUBO DE JERINGA CERDA NATURAL DE 16.5 X 9 X 1cm, PUNTA DE ESCOBETA, FORMA CILINDRICA \",75.00,H87,\"ESCOBILLON PARATUBO DE JERINGA CERDA NATURAL DE 16.5 X 9 X 1cm, PUNTA DE ESCOBET\",UNSPSC,32039090,,0,0,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#00,\"ESCOBILLON PARA TUBO DE KANT CERDA NATURAL DE 12.5 X 7 X 1 CM, PUNTA DE ESCOBETA, FORMA CILINDRICA \",69.00,H87,\"ESCOBILLON PARA TUBO DE KANT CERDA NATURAL DE 12.5 X 7 X 1 CM, PUNTA DE ESCOBETA\",UNSPSC,32039090,,00,00,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#000,\"ESCOBILLON PARA VIALES CERDA NATURAL DE8.5 X4X1CM, PUNTA DE ESCOBETA , FORMA CILINDRICA\",80.00,H87,\"ESCOBILLON PARA VIALES CERDA NATURAL DE8.5 X4X1CM, PUNTA DE ESCOBETA, FORMA CIL\",UNSPSC,32039090,,000,000,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#1,\"ESCOBILLON PARA TUBO DE ENSAYO CHICO CERDA NATURAL DE 20 X 10 X 1.5 CM, PUNTA ESCOBETA. FORMA CILINDRICA \",80.00,H87,ESCOBILLON PARA TUBO DE ENSAYO CHICO CERDA NATURAL DE 20 X 10 X 1.5 CM ,UNSPSC,32039090,,1,1,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#14,\"ESCOBILLON PARA GARRAFON DE 30 L, CERDAS NATURALES DE 100 X 30 X 8 CM, PUNTA DE ESCOBETA, FORMA CILINDRICA \",820.00,H87,\"ESCOBILLON PARA GARRAFON DE 30 L, CERDAS NATURALES DE 100 X 30 X 8 CM,\",UNSPSC,32039090,,14,14,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#15,\"ESCOBILLON PARA MATRAZ VOLUMETRICO 10 ML, CERDA NATURAL DE 12.5 X 7 X 2 CM, PUNTA DOBLADA FORMA CONICA \",68.00,H87,\"ESCOBILLON PARA MATRAZ VOLUMETRICO 10 ML, CERDA NATURAL DE 12.5 X 7 X 2 CM\",UNSPSC,32039090,,15,15,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#16,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 25 ML, CERDA NATURAL DE 16.5 X 8.5 X 2.5 CM, PUNTA DOBLADA , FORMA CONICA \",84.00,H87,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 25 ML, CERDA NATURAL DE 16.5 X 8.5 X 2.5\",UNSPSC,32039090,,16,16,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#17,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 50 ML CERDA NATURAL DE 20 X 9.5 X 3 CM, PUNTA DOBLADA, FORMA CONICA \",120.00,H87,ESCOBILLON PARA MATRAZ VOLUMETRICO DE 50 ML CERDA NATURAL DE 20 X 9.5 X 3 CM,UNSPSC,32039090,,17,17,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#18,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 100 ML, CERDA NATURAL 24 X 11 X 3.5 CM, PUNTA DOBLADA , FORMA CONICA \",148.00,H87,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 100 ML, CERDA NATURAL 24 X 11 X 3.5 CM,\",UNSPSC,32039090,,18,18,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#19,\"ESCOBILLON PARA MATRAZ VOLUMETRICO DE 250 ML CERDA NATURAL DE 27 X 13 X4 CM, PUNTA DOBLADA, FORMA CONICA \",205.00,H87,ESCOBILLON PARA MATRAZ VOLUMETRICO DE 250 ML CERDA NATURAL DE 27 X 13 X4 CM,UNSPSC,32039090,,19,19,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#20,\"ESCOBILLON PARA MATRAZA VOLUMETRICO DE 500 ML, CERDA NATURAL DE 33 X 15 X 4.5 CM, PUNTA DOBLADA, FORMA CONICA \",268.00,H87,\"ESCOBILLON PARA MATRAZA VOLUMETRICO DE 500 ML, CERDA NATURAL DE 33 X 15 X 4.5 CM\",UNSPSC,32039090,,20,20,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#21,\"ESCOBILLON PARA MATRAZA VOLUMETRICO DE 1000 ML CERAD NATURAL 41 X 16 X 5 CM, PUNTA DOBLADA, FORMA CONICA \",324.00,H87,ESCOBILLON PARA MATRAZA VOLUMETRICO DE 1000 ML CERAD NATURAL 41 X 16 X 5 CM,UNSPSC,32039090,,21,21,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#3,\"ESCOBILLON PARA TUBO DE ENSAYO GRANDE CERDA NATURAL DE 26 X 13 X 2.5 CM, PUNTA DE ESCOBETA, FORMA CILINDRICA \",97.00,H87,ESCOBILLON PARA TUBO DE ENSAYO GRANDE CERDA NATURAL DE 26 X 13 X 2.5 CM,UNSPSC,32039090,,3,3,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#4,\"ESCOBILLON PARA PROBETA DE 100 ML, CERDA NATURAL DE 30 X 41 X3 CM, PUNTA ESCOBETA\",159.00,H87,\"ESCOBILLON PARA PROBETA DE 100 ML, CERDA NATURAL DE 30 X 41 X3 CM, PUNTA ESCOBET\",UNSPSC,32039090,,4,4,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#5,\"ESCOBILLON PARA PROBETA DE 250 ML, CERDA NATURAL DE 33 X 14 X 4 CM, PUNTA ESCOBETA, FORMA CILINDRICA \",126.00,H87,\"ESCOBILLON PARA PROBETA DE 250 ML, CERDA NATURAL DE 33 X 14 X 4 CM, PUNTA ESCOBE\",UNSPSC,32039090,,5,5,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#6,\"ESCOBILLON PARA PROBETA DE 500 ML, CERAD NATURAL DE 40 X 15 X 5 CM, PUNTA DE ESCOBETA FORMA CILINDRICA\",296.00,H87,\"ESCOBILLON PARA PROBETA DE 500 ML, CERAD NATURAL DE 40 X 15 X 5 CM, PUNTA DE ESC\",UNSPSC,32039090,,6,6,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,#7,\"ESCOBILLON PARA PROBETA 1000 ML CERDA NATURAL DE 48 X 15 X 6 CM,  CON PUNTA ESCOBETA, FORMA CILINDRICA\",162.00,H87,\"ESCOBILLON PARA PROBETA 1000 ML CERDA NATURAL DE 48 X 15 X 6 CM, PUNTA ESCOBETA\",UNSPSC,32039090,,7,7,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030000978,\"EPTIPS STANDARD 100-5000μL, 5 BOLSAS DE 100 PUNTAS = 500\nPUNTAS MCA. EPPENDORF\",2496.00,H87,\"EPTIPS STANDARD 100-5000μL, 5 BOLSAS DE 100 PUNTAS = 500\nPUNTAS MCA. EPPENDORF\",UNSPSC,32039090,,0030000978,0030000978,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030010027,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR, ESTERIL , 0.1-20 uL , 40 MM , GRIS MEDIO,  100 PUNTAS, ENVASADAS INDIVIDUALMENTE MCA EPPENDORF\",1781.00,H87,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR, ESTERIL , 0.1-20 uL , 40 MM , GRIS MEDIO,  \",UNSPSC,32039090,,0030010027,0030010027,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030010043,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR , ESTERIL , 2-200 uL , 53 MM ,AMARILLO,  100 PUNTAS, ENVASADAS INDIVIDUALMENTE MCA EPPENDORF\",1781.00,H87,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR , ESTERIL , 2-200 uL , 53 MM ,AMARILLO,  100\",UNSPSC,32039090,,0030010043,0030010043,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030010060,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR , ESTERIL , 50-1000 uL , 71 MM ,AZUL,  100 PUNTAS, ENVASADAS INDIVIDUALMENTE MCA EPPENDORF\",1597.00,H87,\"EPT.I.P.S. SINGLES EPPENDORF BIOPUR , ESTERIL , 50-1000 uL , 71 MM ,AZUL,  100 P\",UNSPSC,32039090,,0030010060,0030010060,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0030120094,\"MICROTUBOS SAFE-LOCK 2,0 ML , INCOLORO, 1000 UNIDADES MAC. EPPENDORF\",3277.00,H87,\"MICROTUBOS SAFE-LOCK 2,0 ML , INCOLORO, 1000 UNIDADES MAC. EPPENDORF\",UNSPSC,32039090,,0030120094,0030120094,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,01241,\"ACIDO CLORHIDRICO A.C.S. 1000ML,  FERMONT  -SE REQUIERE DOCUMENTACIÓN Y CARTA DE USO PARA LA ENTREGA-\",495.00,H87,ACIDO CLORHIDRICO A.C.S. FERMONT  SE REQUIERE CARTA DE USO,UNSPSC,32039090,,01241,01241,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0095-1000,ACIDO CLORHIDRICO 1L  MEYER -SE REQUIERE DOCUMENTACIÓN Y CARTA DE USO PARA LA ENTREGA-,877.00,H87,ACIDO CLORHIDRICO MEYER -SE REQUIERE CARTA DE USO-,UNSPSC,32169090,,0095-1000,0095-1000,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,0252-500,\"ACIDO SALICILICO ACS 500G, MEYER \",662.00,H87,\"ACIDO SALICILICO 500 G, MARCA MEYER \",UNSPSC,32169090,,0252-500,0252-500,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,0405-4000,\"ALCOHOL ISOPROPILICO  A.C.S., 4L,ACS, MEYER\",1486.00,H87,\"ALCOHOL ISOPROPILICO  A.C.S., 4L,ACS, MEYER\",UNSPSC,32169090,,0405-4000,0405-4000,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,0776-01,\"FOSFATO DE AMONIO MONOB., CRIST. RA ACS 500 G, J.T.BAKER\",1202.00,H87,\"FOSFATO DE AMONIO MONOB., CRIST. RA ACS 500 G, J.T.BAKER\",UNSPSC,32169090,,0776-01,0776-01,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1000-2L,\"VASO GRIFFIN DE FORMA BAJA, DOBLE ESCALA, GRADUADO, 2000ML PYREX\",588.00,H87,\"VASO GRIFFIN DE FORMA BAJA, DOBLE ESCALA, GRADUADO, 2000ML PYREX\",UNSPSC,32169090,,1000-2L,1000-2L,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1000CPS,\"ESTANDAR DE VISCOSIDAD 1000CPS, 473ML, MARCA BROOKFIELD\",13781.00,H87,\"ESTANDAR DE VISCOSIDAD 1000CPS, 500ML, B\",UNSPSC,32039090,,1000CPS,1000CPS,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,100CPS,\"ESTANDAR DE VISCOSIDAD 100CPS, 473ML, MARCA BROOKFIELD\",13781.00,H87,\"ESTANDAR DE VISCOSIDAD 100CPS, 500ML, BR\",UNSPSC,32169090,,100CPS,100CPS,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1060-200,\"VASO DE PRECIPITADOS BERZELIUS DE FORMA ALTA, CON BOQUILLA, GRADUADO DE 200 ML , PYREX\",219.00,H87,\"VASO DE PRECIPITADOS BERZELIUS DE FORMA ALTA, CON BOQUILLA, GRADUADO DE 200 ML ,\",UNSPSC,32169090,,1060-200,1060-200,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1060-250,COBALTO CLORURO CRISTALES HEXAHIDRATADO,3276.35,H87,COBALTO CLORURO CRISTALES HEXAHIDRATADO,UNSPSC,40019090,,1060-250,1060-250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,40019090\nAN01060825151,10805-165,\"HISOPO APLICADORES PS, PAQUETE CON 100 PIEZAS\",5487.00,BX,\"HISOPO APLICADORES PS, PAQUETE CON 100 PIEZAS\",UNSPSC,32169090,,10805-165,10805-165,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,10CPS,ESTANDAR DE VISCOSIDAD 10CPS 473ML MARCA BROOKFIELD,13781.00,H87,ESTANDAR DE VISCOSIDAD 10CPS 500ML BROOKFIELD,UNSPSC,32039090,,10CPS,10CPS,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,12500CPS,\"ESTANDAR DE  VISCOSIDAD NOMINAL 12500 CPS, 473 ML MARCA BROOKFIELD\",13781.00,H87,\"ESTANDAR DE CALIBRACIÓN VISCOSIDAD NOMINAL 12500 CPS, MARCA BROOKFIELD\",UNSPSC,32169090,,12500CPS,12500CPS,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,14000-100,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,100 mL,KIMAX\",122.00,H87,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,100 mL,KIMAX\",UNSPSC,32169090,,14000-100,14000-100,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,14000-250,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,250 mL,KIMAX\",125.00,H87,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,250 mL,KIMAX\",UNSPSC,32039090,,14000-250,14000-250,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14000-50,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,50 mL,KIMAX\",88.00,H87,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,50 mL,KIMAX\",UNSPSC,32039090,,14000-50,14000-50,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14000-600,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,600 mL,KIMAX\",263.00,H87,\"VASO PRECIPITADO GRIFFIN, REGULAR, FORMA BAJA, GRADUADO,600 mL,KIMAX\",UNSPSC,32039090,,14000-600,14000-600,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1401-14,\"PINZAS DE DISECCIÓN CON DIENTES 14 cm, MARYL\",489.00,H87,\"PINZAS DE DISECCIÓN CON DIENTES 14 cm, MARYL\",UNSPSC,32039090,,1401-14,1401-14,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14030-1000,\"VASO PRECIP. BERZELIUS, CON VERTEDERO, FORMA ALTA, GRADUADO,1000 mL,KIMAX\",532.00,H87,\"VASO PRECIP. BERZELIUS, CON VERTEDERO, FORMA ALTA, GRADUADO,1000 mL,KIMAX\",UNSPSC,32039090,,14030-1000,14030-1000,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14030-200,\"VASO PRECIP. BERZELIUS, CON VERTEDERO, FORMA ALTA, GRADUADO,200 mL,KIMAX\",134.00,H87,\"VASO PRECIP. BERZELIUS, CON VERTEDERO, FORMA ALTA, GRADUADO,200 mL,KIMAX\",UNSPSC,32039090,,14030-200,14030-200,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14346-0002,\"IMPULSOR FLEXIBLE,P. ESTÁNDAR,EPDM, JABSCO\",16059.00,H87,\"IMPULSOR FLEXIBLE,P. ESTÁNDAR,EPDM, JABSCO\",UNSPSC,32039090,,14346-0002,14346-0002,True,,,,75,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14395-1000,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,1000 mL,KIMAX\",313.00,H87,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,1000 mL,\",UNSPSC,36419092,,14395-1000,14395-1000,True,,,,30,01/01/2026,12/12/2027,,,,es_MX,eclass,36419092\nAN01060825151,14395-250,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,250 mL,KIMAX\",202.00,H87,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,250 mL,K\",UNSPSC,32039090,,14395-250,14395-250,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14395-500,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,500 mL,KIMAX\",228.00,H87,\"FRASCO PARA LABORATORIO GL 45 C/ TAPA  (AZUL) Y ANILLO DE POLIPROPILENO,500 mL,K\",UNSPSC,32039090,,14395-500,14395-500,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1454-110,\"PAPEL FILTRO #54 DE 11.0 CM. CAJA. CON 100 PIEZAS, WHATMAN\",3831.00,BX,\"PAPEL FILTRO #54 DE 11.0 CM. CAJA. CON 100 PIEZAS, WHATMAN\",UNSPSC,32039090,,1454-110,1454-110,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,15-122,\"PINZAS DE DISECCIÓN SIN DIENTES 14 cm, MARCA GUTTEK\",271.00,H87,\"PINZAS DE DISECCIÓN SIN DIENTES 14 cm, MARCA GUTTEK\",UNSPSC,32039090,,15-122,15-122,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,15165-5030,\"FRASCO PESAFILTROS,  FORMA BAJA C/ TAPÓN ,  50  X 30,  KIMAX\",1243.00,H87,\"FRASCO PESAFILTROS,  FORMA BAJA C/ TAPÓN ,  50  X 30,  KIMAX\",UNSPSC,32039090,,15165-5030,15165-5030,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1655-100,\"MERCURIO CLORURO  (MERCURICO) A.C.S., 100G,ACS, MEYER\",2807.00,H87,\"MERCURIO CLORURO  (MERCURICO) A.C.S., 100G,ACS, MEYER\",UNSPSC,32039090,,1655-100,1655-100,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1690-100,\"MERCURIO YODURO  ROJO A.C.S., FRASCO 100G,ACS, MEYER\",2804.00,H87,\"MERCURIO YODURO  ROJO A.C.S., FRASCO 100G,ACS, MEYER\",UNSPSC,32169090,,1690-100,1690-100,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,17491LM,\"STANDARD UV LAMP 30\"\" 254NM 17491LM AQUAFINE\",5500.00,H87,\"STANDARD UV LAMP 30\"\" 254NM 17491LM AQUAFINE\",UNSPSC,32169090,,17491LM,17491LM,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1750-500,\"MORFOLINA   ACS, 500ML,ACS, MEYER\",3335.00,H87,\"MORFOLINA   ACS, 500ML,ACS, MEYER\",UNSPSC,33050292,,1750-500,1750-500,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,33050292\nAN01060825151,18140-200,\"CONDENSADOR LIEBIG, GOTEO, LARGO,JUNTAS 24/40,200 MM,KIMAX\",1173.00,H87,\"CONDENSADOR LIEBIG, GOTEO, LARGO,JUNTAS 24/40,200 MM,KIMAX\",UNSPSC,32169090,,18140-200,18140-200,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2095-250,POTASIO PERMANGANATO CRISTAL A.C.S. 250 G MEYER -SE REQUIERE DOCUMENTACIÓN Y CARTA DE USO PARA LA ENTREGA-,1137.00,H87,POTASIO PERMANGANATO CRISTAL A.C.S. -SE REQUIERE CARTA DE USO-,UNSPSC,32039090,,2095-250,2095-250,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,2210-4,\"CLORURO DE COBALTO, 120ML, RICCA CHEMICAL\",3416.00,H87,\"CLORURO DE COBALTO, 120ML, RICCA CHEMICAL\",UNSPSC,32169090,,2210-4,2210-4,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2265-500,SODIO ACETATO ANHIDRO POLVO  A.C.S.MEYER  PRESENTACION DE 500G ,428.00,H87,SODIO ACETATO ANHIDRO POLVO  A.C.S.,UNSPSC,32169090,,2265-500,2265-500,True,,,,80,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2270-2500,SODIO ACETATO CRISTALES TRIHIDRATADO  A.C.S. MEYER PRESENTACION 2500 G,2120.00,H87,SODIO ACETATO CRISTALES TRIHIDRATADO  A.C.S. MEYER,UNSPSC,32169090,,2270-2500,2270-2500,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2270-500,SODIO ACETATO CRISTALES TRIHIDRATADO  A.C.S. MEYER PRESENTACION 500 G,508.00,H87,SODIO ACETATO CRISTALES TRIHIDRATADO  A.C.S. MEYER,UNSPSC,32169090,,2270-500,2270-500,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2281-500,\"AZUL DE LACTOFENOL  p/tinción de hongos, 500 ML HYCEL \",1607.00,H87,\"AZUL DE LACTOFENOL  p/tinción de hongos, 500 ML HYCEL \",UNSPSC,32169090,,2281-500,2281-500,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,23061-10015,\"CAJA PETRI COMPLETA -SET- (BOROSILICATO) 100X15,100 X 15,KIMAX\",246.00,H87,\"CAJA PETRI COMPLETA -SET- (BOROSILICATO) 100X15,100 X 15,KIMAX\",UNSPSC,32169090,,23061-10015,23061-10015,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,23226-652,\"SINGLE-USE, 100 ML (3.4 OZ.) POLYETHYLENE BOTTLES (NIST/ISO 17025 CERTIFICATE), 1000 µmhos (µS), CAJA CON 8 PZ\",6464.00,BX,\"SINGLE-USE, 100 ML (3.4 OZ.) POLYETHYLENE BOTTLES (NIST/ISO 17025 CERTIFICATE), \",UNSPSC,25070490,,23226-652,23226-652,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,247588-100G,\"ACIDO SALICILICO ACS REACTIVO MAYOR O IGUAL AL 99 PORCIENTO, PRESENTACION DE 100 G, SIGMA ALDRICH\",1996.00,H87,\"ACIDO SALICILICO ACS REACTIVO MAYOR O IGUAL AL 99 PORCIENTO, PRESENTACION DE 100\",UNSPSC,40019090,,247588-100G,247588-100G,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,40019090\nAN01060825151,2495-4,\"CUPRIC SULFATE CS, USP / EP BLUE PRIMARY SOLUTION 1 ML = 62.4 MG CUSO₄·5H₂O, FRASCO DE 120ML\",4277.00,H87,\"CUPRIC SULFATE CS, USP / EP BLUE PRIMARY SOLUTION 1 ML = 62.4 MG CUSO₄·5H₂O, FRA\",UNSPSC,32169090,,2495-4,2495-4,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2640-1000,\"TRIETANOLAMINA  REACTIVO, 1L,ACS, MEYER\",715.00,H87,\"TRIETANOLAMINA  REACTIVO, 1L,ACS, MEYER\",UNSPSC,32039090,,2640-1000,2640-1000,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,26505-500,\"MATRAZ ERLENMEYER  C/ ROSCA Y TAPA FENÓLICA,500 mL,KIMAX\",545.00,H87,\"MATRAZ ERLENMEYER  C/ ROSCA Y TAPA FENÓLICA,500 mL,KIMAX\",UNSPSC,32169090,,26505-500,26505-500,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,27060-4000,\"MATRAZ DE FILTRACIÓN, PARED REFORZADA, (KITAZATO),4000 mL,KIMAX\",4365.00,H87,\"MATRAZ DE FILTRACIÓN, PARED REFORZADA, (KITAZATO),4000 mL,KIMAX\",UNSPSC,32039090,,27060-4000,27060-4000,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,30000CPS,\"ESTANDAR DE VISCOSIDAD 30000CPS, 473ML, BROOKFIELD\",10856.00,H87,\"ESTANDAR DE VISCOSIDAD 30000CPS, 500ML, BROOKFIELD\",UNSPSC,32039090,,30000CPS,30000CPS,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,3084LM,\"STANDARD UV LAMP. 30\"\" 254 NM DESINFECTION OZONE AQUAFINE\",5500.00,H87,\"STANDARD UV LAMP. 30\"\" 254 NM DESINFECTION OZONE AQUAFINE\",UNSPSC,32169090,,3084LM,3084LM,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3110-16,\"FERRIC CHLORIDE CS SOLUTION, YELLOW PRIM\",5693.00,H87,\"FERRIC CHLORIDE CS SOLUTION, YELLOW PRIM\",UNSPSC,33050292,,3110-16,3110-16,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,33050292\nAN01060825151,3162-01,\"YODURO DE POTASIO, GRAN. RA ACS 500 G, J.T.BAKER\",5436.00,H87,\"YODURO DE POTASIO, GRAN. RA ACS 500 G, J.T.BAKER\",UNSPSC,32169090,,3162-01,3162-01,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3219L01,\"ROLLO DE MANTA DE CIELO, 200MTS\",5762.00,H87,\"ROLLO DE MANTA DE CIELO, 200MTS\",UNSPSC,32169090,,3219L01,3219L01,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3348-01,\"PIRIDINA RA ACS, 500 ML, J.T.BAKER\",3117.00,H87,\"PIRIDINA RA ACS, 500 ML, J.T.BAKER\",UNSPSC,32039090,,3348-01,3348-01,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,3348-02,\"PIRIDINA RA ACS, 1 L, J.T.BAKER\",2688.00,H87,\"PIRIDINA RA ACS, 1 L, J.T.BAKER\",UNSPSC,32169090,,3348-02,3348-02,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34800-1L-US,HYDRANAL SOLVENT MEDIO P/TITULACION VOLUMETRICA KARL FISCHER FRASCO(S) CON 1 LITRO(S) FLUKA HONEYWELL ,5740.00,H87,HYDRANAL SOLVENT MEDIO P/TITULACION VOLUMETRICA KARL FISCHER FRASCO(S) CON 1 LIT,UNSPSC,32169090,,34800-1L-US,34800-1L-US,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34801-1L-US,\"HYDRANAL TITRAN 5 SOLVENT, MEDIUM FOR VOLUMETRIC TWO-COMPONENT KARL FISCHER, METHANOL-BASED, 1L, HONEYWELL\",5748.00,H87,\"HYDRANAL TITRAN 5 SOLVENT, MEDIUM FOR VOLUMETRIC TWO-COMPONENT KARL FISCHER, MET\",UNSPSC,32169090,,34801-1L-US,34801-1L-US,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34805-1L,\"HYDRANAL - COMPOSITE 5, REAGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER TITRATION, 1L, HONEYWELL\",6571.00,H87,\"HYDRANAL - COMPOSITE 5, REAGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER TITRAT\",UNSPSC,32169090,,34805-1L,34805-1L,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34806-1L,\"HYDRANAL-COMPOSITE 2, TITRATING AGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER TITRATION, 1L, FLUKA HONEYWELL\",5035.00,H87,\"HYDRANAL-COMPOSITE 2, TITRATING AGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER \",UNSPSC,32169090,,34806-1L,34806-1L,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34806-500mL,\"HYDRANAL-COMPOSITE 2, TITRATING AGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER TITRATION, 500ML, FLUKA HONEYWELL\",2673.00,H87,\"HYDRANAL-COMPOSITE 2, TITRATING AGENT FOR VOLUMETRIC ONE-COMPONENT KARL FISCHER \",UNSPSC,32169090,,34806-500mL,34806-500mL,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34813-500mL,HYDRANAL ESTANDAR 5.0 FRASCO(S) CON 500 MILILITRO(S) FLUKA HONEYWELL ,2574.00,H87,HYDRANAL ESTANDAR 5.0 FRASCO(S) CON 500 MILILITRO(S) FLUKA HONEYWELL ,UNSPSC,32169090,,34813-500mL,34813-500mL,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34828-40ML,\"HYDRANAL ESTANDAR DE AGUA 1MG/G P/KARL FISHER, PAQUETE C/10 AMPOLLETAS DE 4ML - FLUKA HONEYWELL\",5655.00,BX,WATER STANDARD 10.0 STANDARD FOR KARL FISCHER TITRATION WATER CONTENT 10mg/g = 1,UNSPSC,32169090,,34828-40ML,34828-40ML,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34849-80ML,\"HYDRANAL WATER STD 10.00 MG/G, 10X8ML, 80ML, HONEYWELL  \",6198.00,BX,\"HYDRANAL WATER STD 10.00 MG/G, 10X8ML, 80ML, HONEYWELL  \",UNSPSC,32169090,,34849-80ML,34849-80ML,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3662-1000,\"PROBETAS GRADUADAS DE POLIPROPILENO NALGENE™, 1000mL\",3399.00,H87,\"PROBETAS GRADUADAS DE POLIPROPILENO NALGENE™, 1000mL\",UNSPSC,32169090,,3662-1000,3662-1000,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3662-2000,\"PROBETA GRADUADA DE POLIPROPILENO GRADUADO 2 L, NALGENE\",7162.00,H87,\"PROBETA GRADUADA DE POLIPROPILENO GRADUADO 2 L, NALGENE\",UNSPSC,32039090,,3662-2000,3662-2000,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,445941-5,\"JARRA GRADUADA, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIEVE , CAPACIDAD 5000 mL, DIVISIÓN NOMINAL 50 ML, DIAMETRO 204mm, ALTURA 270 mm.\",2647.00,H87,\"JARRAS GRADUADAS, PP, ESCALA EN RELIEVE, ALTA TRANSPARENCIA. CON ESCALA EN RELIE\",UNSPSC,32039090,,445941-5,445941-5,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,45060-650,CAMPANA DURHAM TUBO DE CULTIVO LISO 0.7 ML X 6 X 50 KIMAX ,12.00,H87,CAMPANA DURHAM TUBO DE CULTIVO LISO 0.7 ML X 6 X 50 KIMAX ,UNSPSC,32039090,,45060-650,45060-650,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,5000CPS,\"ESTANDAR DE VISCOSIDAD 5000CPS, 473ML, BROOKFIELD\",13781.00,H87,\"ESTANDAR DE VISCOSIDAD 5000CPS, 500ML, BROOKFIELD\",UNSPSC,32039090,,5000CPS,5000CPS,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,500CPS,\"ESTANDAR DE VISCOSIDAD 500CPS, 473ML, BROOKFIELD\",13781.00,H87,\"ESTANDAR DE VISCOSIDAD 500CPS, 500ML, BR\",UNSPSC,32169090,,500CPS,500CPS,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,50CPS,ESTANDAR DE VISCOSIDAD 50CPS 473ML BROOKFIELD,13781.00,H87,ESTANDAR DE VISCOSIDAD 50CPS 500ML BROOKFIELD,UNSPSC,32169090,,50CPS,50CPS,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,5655-01,\"SOL REG  PH10 BORATO AZUL, RA 500 ML, J.T.BAKER\",207.00,H87,\"SOL REG  PH10 BORATO AZUL, RA 500 ML, J.T.BAKER\",UNSPSC,32169090,,5655-01,5655-01,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,5656-01,\"SOL REG PH7 FOSFATO AMARILLO, RA 500 ML, J.T.BAKER\",205.00,H87,\"SOL REG PH7 FOSFATO AMARILLO, RA 500 ML, J.T.BAKER\",UNSPSC,32169090,,5656-01,5656-01,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,5657-01,\"SOL REG PH4 BIFTALATO ROJO, RA 500 ML, J.T.BAKER\",217.00,H87,\"SOL REG PH4 BIFTALATO ROJO, RA 500 ML, J.T.BAKER\",UNSPSC,32169090,,5657-01,5657-01,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,5CPS_,ESTANDAR DE VISCOSIDAD 5CPS 473ML BROOKFIELD,13781.00,H87,ESTANDAR DE VISCOSIDAD 5CPS 500ML BROOK,UNSPSC,32169090,,5CPS,5CPS,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,60000CPS,\"ESTANDAR DE VISCOSIDAD 60000CPS, 473ML, BROOKFIELD\",13781.00,H87,\"ESTANDAR DE VISCOSIDAD 60000CPS, 500ML, BROOKFIELD\",UNSPSC,32169090,,60000CPS,60000CPS,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,606000-1424,\"FLASK 3 NECKS ROUND BOTTOM HW  24/40 24/40 1000ML   (MATRAZ FONDO RED 3 BOCAS),KONTES\",10752.00,H87,\"FLASK 3 NECKS ROUND BOTTOM HW  24/40 24/40 1000ML   (MATRAZ FONDO RED 3 BOCAS),K\",UNSPSC,32169090,,606000-1424,606000-1424,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,62111-686,\"NEODISHER Z , PRESENTACIÓN DE 5 L,\",18020.00,H87,\"NEODISHER Z , PRESENTACIÓN DE 5 L,\",UNSPSC,32039090,,62111-686,62111-686,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,63-293-CH,\"GUANTE DE LATEX NO ESTERIL, PUÑO LARGO, TALLA CHICA, C/50PZAS\",473.00,BX,\"GUANTE DE LATEX NO ESTERIL, PUÑO LARGO, TALLA CHICA, C/50PZAS\",UNSPSC,32039090,,63-293-CH,63-293-CH,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,63-293-M,\"GUANTE DE LATEX NO ESTERIL, PUÑO LARGO, TALLA MEDIANA, CJ/50PZAS\",473.00,BX,\"GUANTE DE LATEX NO ESTERIL, PUÑO LARGO, TALLA MEDIANA, CJ/50PZAS\",UNSPSC,32039090,,63-293-M,63-293-M,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,6402-250,\"EMBUDO DE SEPARACIÓN TIPO PERA, CON TAPA DE VIDRIO LLAVE DE TEFLON, MARCA PYREX\",4260.00,H87,\"EMBUDO DE SEPARACIÓN TIPO PERA, CON TAPA DE VIDRIO LLAVE DE TEFLON, MARCA PYREX\",UNSPSC,32039090,,6402-250,6402-250,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,71321-100G,\"SODIUM BOROHYDRIDE, =99%, 100G, HONEYWELL FLUKA\",5899.00,H87,\"SODIUM BOROHYDRIDE, =99%, 100G, HONEYWELL FLUKA\",UNSPSC,32039090,,71321-100G,71321-100G,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,75109-1,ESPATULA BLANCA DE PLASTICO TRIANGULAR DE ANCHO 110 x LARGO 250 mm.,235.00,H87,ESPATULA BLANCA DE PLASTICO TRIANGULAR DE ANCHO 110 x LARGO 250 mm.,UNSPSC,25070490,,75109-1,75109-1,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,75811-520,\"LECITINA GRANULAR GRADO ALIMENTICIO, SPECTRUM CHEMICAL, 500 G\",11905.00,H87,\"LECITINA GRANULAR GRADO ALIMENTICIO, SPECTRUM CHEMICAL, 500 G\",UNSPSC,32039090,,75811-520,75811-520,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,76952-10G-F,\"MONOHIDRATO DE 1-PENTANOSULFONATO DE SODIO, 10G, SUPELCO\",7279.00,H87,\"MONOHIDRATO DE 1-PENTANOSULFONATO DE SODIO, 10G, SUPELCO\",UNSPSC,32169090,,76952-10G-F,76952-10G-F,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,82904-1,ESPATULA BLANCA DE PLASTICO TRIANGULAR  DE ANCHO 75x LARGO 250 mm.,143.00,H87,ESPATULA BLANCA DE PLASTICO TRIANGULAR  DE ANCHO 75x LARGO 250 mm.,UNSPSC,32169090,,82904-1,82904-1,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,92820G-15,MATRAZ VOLUMETRICO DE VIDRIO CLARO 15ML CLASE A BOCA ANCHA HD C/TAPON DE VIDRIO CERTIFICADO KIMAX ,758.00,H87,MATRAZ VOLUMETRICO DE VIDRIO CLARO 15ML CLASE A BOCA ANCHA HD C/TAPON DE VIDRIO ,UNSPSC,32039090,,92820G-15,92820G-15,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,84-104,\"PINZA DE CORTE DIAGONAL, LONGITUD TOTAL 5\"\", MANGO DE DOBLE INMERSIÓN , PUNTA REDONDA, ACERO, STANLEY\",594.00,H87,\"PINZA DE CORTE DIAGONAL, LONGITUD TOTAL 5\"\", MANGO DE DOBLE INMERSIÓN , PUNTA RED\",UNSPSC,32039090,,84-104,84-104,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,94-243-S,\"GUANTE DE NITRILO , TALLA CHICA, CJA/100PZAS, MICROFLEX\",459.00,BX,\"GUANTE DE NITRILO , TALLA CHICA, CJA/100PZAS, MICROFLEX\",UNSPSC,32039090,,94-243-S,94-243-S,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,94-243-XS,\"GUANTE DE NITRILO , TALLA EXTRA CHICO, CAJA/100 PZAS, MICROFLEX\",459.00,BX,\"GUANTE DE NITRILO , TALLA EXTRA CHICO, CAJA/100 PZAS, MICROFLEX\",UNSPSC,32039090,,94-243-XS,94-243-XS,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,9621-02,\"ACIDO NITRICO RA, 1 L, J.T.BAKER\",1150.00,H87,\"ACIDO NITRICO RA, 1 L, J.T.BAKER\",UNSPSC,32039090,,9621-02,9621-02,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,9681-05,\"ACIDO SULFURICO ACS, 2.5 L, J.T.BAKER\",8892.00,BX,\"ACIDO SULFURICO ACS, 2.5 L, J.T.BAKER\",UNSPSC,32169090,,9681-05,9681-05,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,AE-039,MECHERO ALTAS TEMPERATURAS  PARA GAS L.P. AESA,3594.00,H87,MECHERO ALTAS TEMPERATURAS  PARA GAS L.P. AESA,UNSPSC,32169090,,AE-039,AE-039,True,,,,365,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,AHOMEV1,\"LINTERNA UV DE LUZ NEGRA [BASE MAGNÉTICA] Y [RECARGABLE POR USB] 10 W LUZ NEGRA 395 NM LÁMPARA LED ULTRAVIOLETA, BUSCADOR DE ESCORPIÓN Y DETECTOR DE ORINA DE MASCOTAS CON BATERÍA DE 3000 MAH Y CABLE DE CARGA\",2083.00,H87,LINTERNA UV DE LUZ NEGRA [BASE MAGNÉTICA] Y [RECARGABLE POR USB] 10 W LUZ NEGRA ,UNSPSC,32039090,,AHOMEV1,AHOMEV1,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,ASP-44-1,\"SAL EN PELLET PREMIUM, SACO 20 KG, AQUATROL \",226.00,H87,\"SAL EN PELLET PREMIUM, SACO 20 KG, AQUATROL \",UNSPSC,32039090,,ASP-44-1,ASP-44-1,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,B000J3K5BM,\"LLAVE PARA TAMBOS No. 8-805, LATON\",2645.00,H87,\"LLAVE PARA TAMBOS No. 8-805, LATON\",UNSPSC,33050292,,B000J3K5BM,B000J3K5BM,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,33050292\nAN01060825151,B00736,WP STANDARD 18OZ/532 ML CAJA 500 PZ ,4735.00,BX,WP STANDARD 18OZ/532 ML CAJA 500 PZ ,UNSPSC,32039090,,B00736,B00736,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,B01065,\"BOLSA WHIRL-PAK 532 ML / 18 OZ., 11.5 X 23CM., ESTÉRIL, FRANJA BLANCA PARA ESCRITURA, POLIETILENO, NASCO, CAJA/500\",4519.00,BX,\"BOLSA WHIRL-PAK 532 ML / 18 OZ., 11.5 X 23CM., ESTÉRIL, FRANJA BLANCA PARA ESCRI\",UNSPSC,32039090,,B01065,B01065,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,B01403,WHIRL-PAK® STAND UP THIO-BAGS® - 10 OZ. (300 ML) - CAJA DE 100,3311.00,BX,WHIRL-PAK® STAND UP THIO-BAGS® - 10 OZ. (300 ML) - CAJA DE 100,UNSPSC,32039090,,B01403,B01403,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,BPC120010,BOBINA DE PAPEL CREPADO GRADO MEDICO DE1.20 CMS. DE ANCHO POR 10 KGS. DE PESO,1920.00,H87,BOBINA DE PAPEL CREPADO GRADO MEDICO DE1.20 CMS. DE ANCHO POR 10 KGS. DE PESO,UNSPSC,32039090,,BPC120010,BPC120010,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,CTV001,CINTA TESTIGO DE VAPOR ESTERITECH EN VAPOR A PRESION DE 18MM. DE ANCHO X 50 M. DE LARGO MCA: ESTERITECH,109.00,H87,CINTA TESTIGO DE VAPOR ESTERITECH EN VAPOR A PRESION DE 18MM. DE ANCHO X 50 M. D,UNSPSC,32039090,,CTV001,CTV001,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,CUB-12,\"CUBREBOCAS DESECHABLE TERMOSELLADO, CON SOPORTE NASAL, TRES CAPAS, COLOR BLANCO, UNISEAL \",2.00,H87,\"CUBREBOCAS DESECHABLE TERMOSELLADO, CON SOPORTE NASAL, TRES CAPAS, COLOR BLANCO,\",UNSPSC,32039090,,CUB-12,CUB-12,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,E6275,\"ENZYTEC SULFITE (SO2-TOTAL), R-BIOPHARM AG  KIT C/30 TEST\",11450.00,KT,\"ENZYTEC SULFITE (SO2-TOTAL), R-BIOPHARM AG \",UNSPSC,32039090,,E6275,E6275,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,E8226 ,ENZYTEC LIQUID ACETIC ACID,14402.00,KT,ENZYTEC LIQUID ACETIC ACID,UNSPSC,32169090,,E8226 ,E8226 ,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,EZS-6,\"STEAM 10-6 VIAL G. STEAROTHERMOPHILUS PARA VAPOR, CAJA CON 100 PIEZAS,\",17109.00,BX,\"STEAM 10-6 VIAL G. STEAROTHERMOPHILUS PARA VAPOR, CAJA CON 100 PIEZAS,\",UNSPSC,32169090,,EZS-6,EZS-6,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,F148560,\"CAPILLARY PISTONS CP1000, 2X96 TIPACK, MICROPIPETAS, GILSON\",10475.00,H87,\"CAPILLARY PISTONS CP1000, 2X96 TIPACK, MICROPIPETAS, GILSON\",UNSPSC,32169090,,F148560,F148560,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,F171703,\"PUNTAS CON FILTRO PIPETMAN  TIPACK DE 100 a 1000 µl, CON FILTRO, CAJA DE 10 RACKS CON 96 PUNTAS CADA UNO, GILSON\",6582.00,BX,\"PUNTAS CON FILTRO PIPETMAN  TIPACK DE 100 a 1000 µl, CON FILTRO, GILSON\",UNSPSC,32039090,,F171703,F171703,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F36711-0012,\"ESPATULA DOBLE DE ACERO INOXIDABLE C/CUCHARA 5ML, LARGO 30.5CM BEL-ART\",2521.00,H87,\"ESPATULA DOBLE DE ACERO INOXIDABLE C/CUCHARA 5ML, LARGO 30.5CM BEL-ART\",UNSPSC,25070490,,F36711-0012,F36711-0012,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,25070490\nAN01060825151,F37110-0002,\"SP BEL-ART SPINBAR TEFLON OCTAGON MAGNETIC STIRRING BAR; 50.8 X 8MM, WHITE\",320.00,H87,\"SP BEL-ART SPINBAR TEFLON OCTAGON MAGNETIC STIRRING BAR; 50.8 X 8MM, WHITE\",UNSPSC,32039090,,F37110-0002,F37110-0002,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37120-0025,\"SP BEL-ART SPINBAR TEFLON POLYGON MAGNETIC STIRRING BAR; 25 X 8MM, WHITE, WITHOUT PIVOT RING\",256.00,H87,\"SP BEL-ART SPINBAR TEFLON POLYGON MAGNETIC STIRRING BAR; 25 X 8MM, WHITE, WITHOU\",UNSPSC,32039090,,F37120-0025,F37120-0025,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37120-0040,\"BARRA MAGNETICA DE 40X8 MM, MARCA BELART\",382.00,H87,\"BARRA MAGNETICA DE 40X8 MM, MARCA BELART\",UNSPSC,32039090,,F37120-0040,F37120-0040,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37120-0070,BARRA MAGNETICA DE 70 X 10 MM MARCA BELART,760.00,H87,BARRA MAGNETICA DE 70 X 10 MM,UNSPSC,32039090,,F37120-0070,F37120-0070,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37122-0025,BARRA MAGNETICA CON ANILLO 25 x 6mm BELART,256.00,H87,BARRA MAGNETICA CON ANILLO 25 x 6mm BELART,UNSPSC,32039090,,F37122-0025,F37122-0025,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37122-0050,\"BARRA MAGNETICA 50 x 8mm (CON MUESCA), BELART\",332.00,H87,\"BARRA MAGNETICA 50 x 8mm (CON MUESCA), BELART\",UNSPSC,32039090,,F37122-0050,F37122-0050,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F37786-1000,\"SUJETADOR P/BARRA MAGNETICA DE HASTA 80MM DE DIAMETRO BEL-ART\n\",1322.00,H87,\"SUJETADOR P/BARRA MAGNETICA DE HASTA 80MM DE DIAMETRO BEL-ART\n\",UNSPSC,32039090,,F37786-1000,F37786-1000,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,FES-01R,CARTUCHO DE REPUESTO PARA FILTRO ESTÁNDAR,378.00,H87,CARTUCHO DE REPUESTO PARA FILTRO ESTÁNDAR,UNSPSC,32039090,,FES-01R,FES-01R,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,HI5124,\"SOLUCION PH 12.45, +/- 0.01PH, 500 ML, HANNA\",1005.00,H87,\"SOLUCION PH 12.45.500 ML,+/- 0.01PH,CAJA, HANNA\",UNSPSC,33050292,,HI5124,HI5124,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,33050292\nAN01060825151,HI6031,\"SOLUCION CONDUCTIVIDAD 1413 US/CM C/CERT, 500ML, HANNA\",977.00,H87,\"SOLUCION CONDUCTIVIDAD 1413 US/CM C/CERT, HANNA\",UNSPSC,20360106,,HI6031,HI6031,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,33050292\nAN01060825151,HI7021L,\"SOLUCION 240 MV, (500 ML), HANNA\",1050.00,H87,\"SOLUCION 240 MV, (500 ML), HANNA\",UNSPSC,32169090,,HI7021L,HI7021L,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,HI7022L,\"SOLUCIÓN 470 MV, 500 ML, HANNA\",1050.00,H87,\"SOLUCIÓN 470 MV, 500 ML, HANNA\",UNSPSC,32169090,,HI7022L,HI7022L,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,HI7031L,\"SOLUCION DE 1413 US, 500 ML, HANNA\",561.00,H87,\"SOLUCION DE 1413 US, 500 ML, HANNA\",UNSPSC,32169090,,HI7031L,HI7031L,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,HI7033L,\"SOLUCION DE 84 US, 500 ML, HANNA\",561.00,H87,\"SOLUCION DE 84 US, 500 ML, HANNA\",UNSPSC,32169090,,HI7033L,HI7033L,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,MX11075535004,\"EXTRAN MA02, LIQUIDO NEUTRO , CONCENTRADO , PRESENTACION DE 5 L, MARCA SUPELCO \",1619.00,H87,\"EXTRAN MA02, LIQUIDO NEUTRO , CONCENTRADO , PRESENTACION DE 5 L, MARCA SUPELCO \",UNSPSC,32169090,,MX11075535004,MX11075535004,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,PAR028,\"BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO 12 X 26 X 4 CM. CON HILO, MARCA PMG. CAJA CON 1000 PIEZAS\",1229.00,BX,\"BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO 12 X 26 X 4 CM. CON HILO, MARCA PMG\",UNSPSC,32169090,,PAR028,PAR028,True,,,,70,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,PAR029,\"BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO DE 14 X 33 X 4.5 CM. CON HILO, CAJA C/1000PZ MARCA PMG.\",1661.00,BX,\"BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO DE 14 X 33 X 4.5 CM. CON HILO, CAJA\",UNSPSC,32039090,,PAR029,PAR029,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PAR032,\"BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO C/HILO DE 18x33x6CM, PMG, CAJA CON 1000 UNIDADES\",2009.00,BX,BOLSA PARA ESTERILIZAR DE PAPEL GRADO MEDICO C/HILO DE 18x33x6CM. PMG,UNSPSC,32039090,,PAR032,PAR032,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PINZA-PESAJE1,\"PINZAS DE ACERO INOXIDABLE,15 CM DE LARGO, PUNTA AULADA, ADECUADA PARA SUJETAR PESAS DE 1G HASTA 200G.\",633.00,H87,\"PINZAS DE ACERO INOXIDABLE,15 CM DE LARGO, PUNTA AULADA, ADECUADA PARA SUJETAR P\",UNSPSC,32039090,,PINZA-PESAJE1,PINZA-PESAJE1,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PINZA-PESAJE2,\"PINZA DE ACERO INOXIDABLE, 13 CM DE LARGO, PUNTA RECTA DE CERÁMICA, ADECUADA PARA SUJETAR PESAS DE 1 MG HASTA 10 G\",2060.00,H87,\"PINZA DE ACERO INOXIDABLE, 13 CM DE LARGO, PUNTA RECTA DE CERÁMICA, ADECUADA PAR\",UNSPSC,32039090,,PINZA-PESAJE2,PINZA-PESAJE2,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PINZA-PESAJE3,\"PINZA DE ACERO INOXIDABLE, 13 CM DE LARGO, PUNTA CURVA DE CERÁMICA, ADECUADA PARA SUJETAR PESAS DE 1 G HASTA 200 G\",1954.00,H87,\"PINZA DE ACERO INOXIDABLE, 13 CM DE LARGO, PUNTA CURVA DE CERÁMICA, ADECUADA PAR\",UNSPSC,32039090,,PINZA-PESAJE3,PINZA-PESAJE3,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PM996,\"PAPEL PARAFILM, 100MM X 38M, 4\"\"\",1164.00,H87,\"PAPEL PARAFILM, 100MM X 38M, 4\"\"\",UNSPSC,32039090,,PM996,PM996,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PT4144,\"MEDIO PREPARADO DE BURKHOLDERIA, PLACA 90 X 15 PAQUETE CON 10 PLACAS ,CAJA CON 20 PAQUETES, MCD LABS\",21252.00,BX ,\"MEDIO PREPARADO DE BURKHOLDERIA 90 X 15\nPAQUETE CON 10 PLACAS ,MARCA MC DE LAB\",UNSPSC,32039090,,PT4144,PT4144,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,S11M002,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 4.0 HACH, 500 ML , HACH\",5663.00,H87,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 4.0\",UNSPSC,32039090,,S11M002,S11M002,True,,,,7,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,S11M004,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 7.0 HACH, 500 ML, HACH\",5654.00,H87,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 7.0\",UNSPSC,32039090,,S11M004,S11M004,True,,,,30,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,S11M007,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 10 HACH., 500 ML , HACH\",5663.00,H87,\"SOLUCIÓN ESTANDAR BUFFER , IUPAC, pH 10.\",UNSPSC,32169090,,S11M007,S11M007,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,S1-40UNIBIND,\"CARPETAS DE CARÁTULA TIPO ACETATO KRISTAL, Y CONTRAPORTADA CLARA TRASLUCIDA (OPACA), HOJAS 1 A 40  CON 96 PIEZAS\",6360.00,BX,\"CARPETAS DE CARÁTULA TIPO ACETATO KRISTAL, Y CONTRAPORTADA CLARA TRASLUCIDA (OPA\",UNSPSC,32169090,,S1-40UNIBIND,S1-40UNIBIND,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,S1-41-80UNIBIND,\"CARPETAS DE CARÁTULA TIPO ACETATO KRISTAL, Y CONTRAPORTADA CLARA TRASLUCIDA (OPACA), HOJAS 41 A 80  CON 72 PIEZAS \",5090.00,BX,\"CARPETAS DE CARÁTULA TIPO ACETATO KRISTAL, Y CONTRAPORTADA CLARA TRASLUCIDA (OPA\",UNSPSC,32169090,,S1-41-80UNIBIND,S1-41-80UNIBIND,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,SASU-6,STERILAMP II® B. SUBTILIS PAQUETE CON 100 ME,30756.00,BX,STERILAMP II® B. SUBTILIS,UNSPSC,32039090,,SASU-6,SASU-6,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,TQ-2040,BIDON 20L POLIETILENO C/TAPA,303.00,H87,BIDON 20L POLIETILENO C/TAPA,UNSPSC,32039090,,TQ-2040,TQ-2040,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,TX714K,LARGE ALPHA SNAP SWAB LOW TAC. 50 BOLSAS C/ 20 PZAS.,56946.00,BX,LARGE ALPHA SNAP SWAB LOW TAC. 50 BOLSAS C/ 20 PZAS.,UNSPSC,32039090,,TX714K,TX714K,True,,,,5,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,TX715,\"ALPHA SAMPLING SWAB, POLYESTER  FOR HPLC SAMPLING/CLEANING VALIDATION, CAJA C/10 BOLSAS, TEXWIPE\",15909.00,BX,\"ALPHA SAMPLING SWAB, POLYESTER  FOR HPLC SAMPLING/CLEANING VALIDATION, CAJA C/10\",UNSPSC,20240103,,TX715,TX715,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,U216-07,\"POLIETILENGLICOL 400, 500 ML, J T.BAKER\",2669.00,H87,\"POLIETILENGLICOL 400, 500 ML, J T.BAKER\",UNSPSC,32039090,,U216-07,U216-07,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,VB090F-30,BOLSAS DE POLVO DE FORRO POLAR PARA EXTRACTORES DE POLVO ,5638.00,XPK,BOLSAS DE POLVO DE FORRO POLAR PARA EXTR,UNSPSC,32039090,,VB090F-30,VB090F-30,True,,,,45,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,YC185,FILTRO DE POLIESTER PARA BOMBA ZANASI,3321.00,H87,FILTRO DE POLIESTER PARA BOMBA ZANASI,UNSPSC,32169090,,YC185,YC185,True,,,,40,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,0596-19,\"ACETATO DE AMONIO CRISTAL RA ACS,  1KG, JT.BAKER\",1870.00,H87,\"ACETATO DE AMONIO CRISTAL RA ACS,  1KG, JT.BAKER\",UNSPSC,36419092,,0596-19,0596-19,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,36419092\nAN01060825151,4218-03,\"AGUA HPLC, 4 L, J.T.BAKER\",1315.00,H87,\"AGUA HPLC, 4 L, J.T.BAKER\",UNSPSC,32169090,,4218-03,4218-03,True,,,,25,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,4244-01,\"ZINC GRAN. (20 MALLAS) RA ACS, 500 G, J.T.BAKER\",4308.00,H87,\"ZINC GRAN. (20 MALLAS) RA ACS, 500 G, J.T.BAKER\",UNSPSC,32169090,,4244-01,4244-01,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,9054-02,\"1-BUTANOL RA ACS, 1 L, J.T.BAKER\",905.00,H87,\"1-BUTANOL RA ACS, 1 L, J.T.BAKER\",UNSPSC,32169090,,9054-02,9054-02,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,34800-2.5L-US,\"HYDRANAL- SOLVENT, REAGENT FOR VOLUMETRIC TWO-COMPONENT KF TITRATION, 2.5L,  HONEYWELL\",7402.00,H87,\"HYDRANAL- SOLVENT, REAGENT FOR VOLUMETRIC TWO-COMPONENT KF TITRATION, 2.5L,  HON\",UNSPSC,32169090,,34800-2.5L-US,34800-2.5L-US,True,,,,20,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,TB-R28,TAPA ROSCA 28 BAQUELITA BAJA NEGRA,5.00,H87,TAPA ROSCA 28 BAQUELITA BAJA NEGRA,UNSPSC,32169090,,TB-R28,TB-R28,True,,,,25,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,HI5016,\"SOLUCION PH 1.68.500 ML,+/- 0.01, 25 °C , 500 ML , HANNA\",1018.00,H87,\"SOLUCION PH 1.68.500 ML,+/- 0.01, 25 °C , 500 ML , HANNA\",UNSPSC,32169090,,HI5016,HI5016,True,,,,50,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,IMAN61X100-15,IMÁN CON ADHESIVO CALIBRE 15 CON (61X100 CM),693.00,H87,IMÁN CON ADHESIVO CALIBRE 15 CON (61X100 CM),UNSPSC,32039090,,IMAN61X100-15,IMAN61X100-15,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,F148314,PUNTAS 10-100UL CLARAS NO ESTERIL DE PISTON CAPILAR MICROMAN CP100 C/960 GILSON,25808.00,BX,PUNTAS 10-100UL CLARAS NO ESTERIL DE PISTON CAPILAR MICROMAN CP100 C/960 GILSON,UNSPSC,32169090,,F148314,F148314,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,ETIQUETA-00,\"ETIQUETA ADHESIVA, MEDIDA DE 7X4 CMS. ETIQUETA DE IDENTIFICACION PARA REACTIVOS  (039-PT-21-00119-A06)\",7.00,H87,\"ETIQUETA ADHESIVA, MEDIDA DE 7X4 CMS. ETIQUETA DE IDENTIFICACION PARA REACTIVOS \",UNSPSC,\"\t40019090\",,ETIQUETA-00,ETIQUETA-00,True,,,,30,01/01/2026,12/12/2027,,,,es_MX,eclass,40019090\nAN01060825151,ETIQUETA-01,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE RESIDUO PELIGROSO OXIDANTE.\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE RESIDUO PELIGROSO OXIDA\",UNSPSC,32039090,,ETIQUETA-01,ETIQUETA-01,True,,,,120,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,ETIQUETA-02,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO TOXICO\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO TOXI\",UNSPSC,\"\t40019090\",,ETIQUETA-02,ETIQUETA-02,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,ETIQUETA-03,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO VARIOS\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO VARI\",UNSPSC,\"\t40019090\",,ETIQUETA-03,ETIQUETA-03,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,ETIQUETA-04,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO LIQUIDO INFLAMABLE\"\"\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO LIQU\",UNSPSC,\"\t40019090\",,ETIQUETA-04,ETIQUETA-04,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,ETIQUETA-05,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO CORRISIVO\"\"\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO CORR\",UNSPSC,\"\t40019090\",,ETIQUETA-05,ETIQUETA-05,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,ETIQUETA-06,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO SUSTANCIA INFECCIOSA\"\"\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO SUST\",UNSPSC,\"\t40019090\",,ETIQUETA-06,ETIQUETA-06,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,ETIQUETA-07,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO SOLIDO INFLAMABLE\"\"\",18.00,H87,\"ETIQUETA ADHESIVA, MEDIDAS DE 21.5X14 CMS ., ETIQUETA DE \"\"RESIDUO PELIGROSO SOLI\",UNSPSC,\"\t40019090\",,ETIQUETA-07,ETIQUETA-07,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,C2P07AL,TINTA HP 62XL TRICOLOR  ALTO RENDIMIENTO,1791.00,H87,TINTA HP 62XL TRICOLOR  ALTO RENDIMIENTO,UNSPSC,\"\t40019090\",,C2P07AL,C2P07AL,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,1190,ROLLOS DE PAPEL SATINADO 57 MM X 20 M PAQUETE CON 48 PIEZAS (PRINTAFORM),1458.00,H87,ROLLOS DE PAPEL SATINADO 57 MM X 20 M PAQUETE CON 48 PIEZAS (PRINTAFORM),UNSPSC,\"\t40019090\",,1190,1190,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,COD.2005,\"ROLLO PARA CALOR HUMEDO, PRESIÓN DE VAPOR SATURADO DE 1,1 Bar a 121oC POR UN TIEMPO MÍNIMO DE 10 min. O BIEN a 2,2 Bar a 134oC POR UN TIEMPO MÍNIMO DE 2 MINUTOS.  EFELAB, CAJA CON 50 PIEZAS\",23476.00,BX,\"ROLLO PARA CALOR HUMEDO, PRESIÓN DE VAPOR SATURADO DE 1,1 Bar a 121oC POR UN TIE\",UNSPSC,24209090,,COD.2005,COD.2005,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,24209090\nAN01060825151,C2P05AL,TINTA HP 62XL COLOR NEGRO  ALTO RENDIMIENTO. ,1692.00,H87,TINTA HP 62XL COLOR NEGRO  ALTO RENDIMIENTO. ,UNSPSC,24209090,,C2P05AL,C2P05AL,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,24209090\nAN01060825151,252711,AGAR SOYA TRIPTICASEINA C/LECITINA Y POLIS 80. PAQUETE CON 10 PLACAS,498.00,XPK,AGAR SOYA TRIPTICASEINA C/LECITINA Y POLIS 80. PAQUETE CON 10 PLACAS,UNSPSC,32169090,,252711,252711,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,PTC5146,\"MACCONKEY BROTH  EP/USP, PACK OF 10 X100 mL FLASK\",2308.00,XPK,\"MACCONKEY BROTH  EP/USP, PACK OF 10 X100 mL FLASK\",UNSPSC,32169090,,PTC5146,PTC5146,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,24209090\nAN01060825151,PT7114,\"AGAR  MACCONKEY PLACA PREPARADA CON 10 PIEZAS (90 X15 MM), UNIDAD PAQUETE\",241.00,XPK,\"AGAR  MACCONKEY PLACA PREPARADA CON 10 PIEZAS (90 X15 MM), UNIDAD PAQUETE\",UNSPSC,32169090,,PT7114,PT7114,True,,,,15,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,PT4524,\"AGAR M-ENDOLES CAJA C/50,  PLACAS  DE 60 MM ,MCD LAB \",249.00,XPK,\"AGAR M-ENDOLES CAJA C/50,  PLACAS  DE 60 MM ,MCD LAB \",UNSPSC,32169090,,PT5204,PT5204,True,,,,60,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,B0CFF1HV5J,\"BOLSAS DE MALLA PLASTIFICADA CON CIERRE, 33 X 23 CM,\nPAQUETE CON 38 PIEZAS\",713.00,XPK,\"BOLSAS DE MALLA PLASTIFICADA CON CIERRE, 33 X 23 CM,\nPAQUETE CON 38 PIEZAS\",UNSPSC,\"\t40019090\",,B0CFF1HV5J,B0CFF1HV5J,True,,,,7,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,B0B6N98LCN,\"BOLSAS DE MALLA PLASTIFICADA CON CIERRE, 24 X 33 CM,\nPAQUETE CON 20 PIEZAS DE COLORES ( INCLUIDAS 4\nBLANCAS, 4 VERDES, 4 AMARILLAS, 4 ROSAS y 4 AZULES\nCLARAS.)\",565.00,XPK,\"BOLSAS DE MALLA PLASTIFICADA CON CIERRE, 24 X 33 CM,\nPAQUETE CON 20 PIEZAS DE CO\",UNSPSC,\"\t40019090\",,B0B6N98LCN,B0B6N98LCN,True,,,,7,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,1821-3.5L ,\"ALCOHOL ETILICO 70%, 3.5L, HYCEL\",1055.00,H87,\"ALCOHOL ETILICO 70%, 3.5L, HYCEL\",UNSPSC,40019090,,1821-3.5L ,1821-3.5L ,True,,,,10,01/01/2026,12/12/2027,,,,es_MX,eclass,\"\t40019090\"\nAN01060825151,3340-FO500,\"MATRAZ KJENDAHL PARA APARATO DE DESTILACIÓN, CAPACIDAD 500 ML, JUNTA 29/4\",1134.00,H87,\"MATRAZ KJENDAHL APARATO DE DESTILACIÓN, 500 ML, JUNTA 29/4\",UNSPSC,32039090,,3340-FO500,3340-FO500,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,238973,STD DE CONDUCTIVIDAD 1.3US/CM 250ML HAMILTON,10624.00,H87,STD DE CONDUCTIVIDAD 1.3US/CM 250ML HAMILTON,UNSPSC,32039090,,238973,238973,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,250-160-070,STD DE CONDUCTIVIDAD TDS 10US/CM 500ML SCP SCIENCE,1220.00,H87,STD DE CONDUCTIVIDAD TDS 10US/CM 500ML SCP SCIENCE,UNSPSC,32039090,,250-160-070,250-160-070,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,250-160-050,STD DE CONDUCTIVIDAD/TDS 5US/CM 500ML SCP SCIENCE,1220.00,H87,STD DE CONDUCTIVIDAD/TDS 5US/CM 500ML SCP SCIENCE,UNSPSC,32039090,,250-160-050,250-160-050,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1259H,\"SULFURO DE SODIO NONAHIDRATADO, ACS , 98.0 PORCIENTO , PRESENTACION 25 G ,  MARCA AK SCIENTIFIC\",5680.00,H87,\"SULFURO DE SODIO NONAHIDRATADO, ACS , 98.0% , PRESENTACION 25 G ,AK SCIENTIFIC\",UNSPSC,32039090,,1259H,1259H,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37411,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 1000 ML, BORO 3.3 NS 24/29 TAPÓN EN PP,BRAND\",3659.00,H87,\"MATRAZ AFORADO A DE-M TOPACIO 1000 ML, BORO 3.3 NS 24/29 TAPÓN EN PP\",UNSPSC,32039090,,37411,37411,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,37453,\"MATRAZ AFORADO BLAUBRAND A DE-M TOPACIO 1000 ML, BORO 3.3 NS 24/29 TAPÓN VIDRIO,BRAND\",4144.00,H87,\"MATRAZ AFORADO A DE-M TOPACIO 1000 ML, BORO 3.3 NS 24/29 TAPÓN VIDRIO\",UNSPSC,32039090,,37453,37453,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,35154,\"PROBETA GRAD. ALTA A DE-M,DE-M DE LOTE 500 ML: 5 ML, PMP, GRAD. AZUL, CAJA C/2 PZ, BRAND\",3689.00,BX,\"PROBETA GRAD. ALTA A DE-M,DE-M 500 ML:5 ML, PMP, GRAD. AZUL, CAJA C/2 PZ\",UNSPSC,32039090,,35154,35154,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,36938,\"MATRAZ AFOR. BLAUBRAND, CL.A, USP, DE-M 5 ML, BORO 3.3, NS 10/19, TAPÓN EN PP, CAJA C/2 PZ, BRAND\",2387.00,BX,\"MATRAZ AFOR. BLAUBRAND, CL.A, USP, DE-M 5 ML, BORO 3.3, NS 10/19, TAPÓN EN PP, C\",UNSPSC,32039090,,36938,36938,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,40300,\"MORTERO CON MANO CON PICO 300ML MARCA DUVE\n\",361.00,H87,\"MORTERO CON MANO CON PICO 300ML MARCA DUVE\n\",UNSPSC,32039090,,40300,40300,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,60105,CRISOL DE PORCELANA DE 15ML. FORMA ALTA. COORSTEK,761.00,H87,CRISOL DE PORCELANA DE 15ML. FORMA ALTA. COORSTEK,UNSPSC,32039090,,60105,60105,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,66036,\"CRISOL DE PORCELANA 20ML, DE COMBUSTION130X20X13MM, MARCA COORS\",811.00,H87,\"CRISOL DE PORCELANA 20ML, DE COMBUSTION130X20X13MM, MARCA COORS\",UNSPSC,32039090,,66036,66036,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,66135,\"CRISOL DE PORCELANA 17ML, DIAMETRO 41MM, ALTURA 26MM, MARCA COORS\",666.00,H87,\"CRISOL DE PORCELANA 17ML, DIAMETRO 41MM, ALTURA 26MM, MARCA COORS\",UNSPSC,32039090,,66135,66135,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,72900,\"ESPÁTULAS 100 X 240 MM, METAL DETECTABLES\n\",639.00,H87,\"ESPÁTULAS 100 X 240 MM, METAL DETECTABLES\n\",UNSPSC,32169090,,72900,72900,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,193640,\"TYPE B LONG CELL, 9 mm LG BULB\",18905.00,H87,\"TYPE B LONG CELL, 9 mm LG BULB\",UNSPSC,32039090,,193640,193640,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,193902,\"TYPE B ROD, FOR 9 mm LONG CELL\",18491.00,H87,\"TYPE B ROD, FOR 9 mm LONG CELL\",UNSPSC,32039090,,193902,193902,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,200500.1,\"ASA PARA SIEMBRA POR DISEMINACIÓN EN SUPERFICIE.\nFABRICADA EN POLIESTIRENO BLANCO. ESTÉRIL POR ÓXIDO DE ETILENO. LONGITUD TOTAL:\n149 MM. LONGITUD DE LA BASE: 40 MM. PAQUETE CON 5 PIEZAS, CAJA CON 1000\",6137.00,BX,ASA PARA SIEMBRA POR DISEMINACIÓN EN SUPERFICIE 5PZAS,UNSPSC,32039090,,200500.1,200500.1,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,200510.1,\"ASA PARA SIEMBRA POR DISEMINACIÓN EN SUPERFICIE.\nFABRICADA EN POLIESTIRENO BLANCO. ESTÉRIL POR ÓXIDO DE ETILENO. LONGITUD TOTAL:\n149 MM. LONGITUD DE LA BASE: 40 MM. PAQUETE CON 1 PIEZAS, CAJA CON 1000.\",9353.00,BX,ASA PARA SIEMBRA POR DISEMINACIÓN EN SUPERFICIE 1PZA,UNSPSC,32039090,,200510.1,200510.1,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1101250,\"VASO DE PRECIPITADO FORMA BAJA GRADUADO DE 250 ML MARCA CIVEO \n\",114.00,H87,\"VASO DE PRECIPITADO FORMA BAJA GRADUADO DE 250 ML MARCA CIVEO \n\",UNSPSC,32039090,,1101250,1101250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,10300210,\"GRADE 589/3 FILTER FOR FINE PRECIPITATE RETENTION, 110 mm CIRCLE (100 PCS)\",3125.00,BX,\"GRADE 589/3 FILTER FOR FINE PRECIPITATE RETENTION, 110 mm CIRCLE (100 PCS)\",UNSPSC,32039090,,10300210,10300210,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,10300211,\"GRADE 589/3 FILTER FOR FINE PRECIPITATE RETENTION, 125 mm CIRCLE (100 PCS)\",3543.00,BX,\"GRADE 589/3 FILTER FOR FINE PRECIPITATE RETENTION, 125 mm CIRCLE (100 PCS)\",UNSPSC,32039090,,10300211,10300211,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,10463062,WHATMAN SPARTAN 30/0.2 RC 500/PK,52423.00,XPX,WHATMAN SPARTAN 30/0.2 RC 500/PK,UNSPSC,32039090,,10463062,10463062,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,218018658,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y ANILLO DE VERTIDO DE PP ( AZUL), GL 45, 10000 ML ,DURAN\",8309.00,H87,\" DURAN® FRASCOS PARA LABORATORIO CON ROSCA DIN, GRADUADOS, CON TAPA A ROSCA Y AN\",UNSPSC,32039090,,218018658,218018658,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1050430250,\"POTASIO YODURO, 250 G, SUPELCO\",5330.00,H87,\"POTASIO YODURO, 250 G, SUPELCO\",UNSPSC,32039090,,1050430250,1050430250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,0084-01,\"ACIDO BORICO GRAN. RA ACS, 500 G, J.T.BAKER\",1629.00,H87,\"ACIDO BORICO GRAN. RA ACS, 500 G, J.T.BAKER\",UNSPSC,32169090,,0084-01,0084-01,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,0095-2500,\"ACIDO CLORHIDRICO  36.5-38%  ACS, 2.5L,ACS, MEYER -SE REQUIERE CARTA DE USO -\",2193.75,H87,\"ACIDO CLORHIDRICO  36.5-38%  ACS, 2.5L,ACS, MEYER -SE REQUIERE CARTA DE USO -\",UNSPSC,32169090,,0095-2500,0095-2500,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,1820-047,PAPEL FIBRA DE VIDRIO GF/A DE 4.7 CMS. CJ. C/100 PZ,2510.00,H87,PAPEL FIBRA DE VIDRIO GF/A DE 4.7 CMS. CJ. C/100 PZ,UNSPSC,32039090,,1820-047,1820-047,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,1822-047,PAPEL MICROFIBRA DE VIDRIO GF/C 4.7CM C/100 WHATMAN,5811.00,H87,PAPEL MICROFIBRA DE VIDRIO GF/C 4.7CM C/100 WHATMAN,UNSPSC,32039090,,1822-047,1822-047,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-10,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,10 mL,KIMAX\",390.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,10 mL,KIMAX\",UNSPSC,32039090,,20024-10,20024-10,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-100,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,100 mL,KIMAX\",518.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,100 mL,KIMAX\",UNSPSC,32039090,,20024-100,20024-100,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-2000,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,2000 mL,KIMAX\",2454.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,2000 mL,KIMAX\",UNSPSC,32039090,,20024-2000,20024-2000,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-25,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,25 mL,KIMAX\",486.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,25 mL,KIMAX\",UNSPSC,32039090,,20024-25,20024-25,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-250,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,250 mL,KIMAX\",671.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,250 mL,KIMAX\",UNSPSC,32039090,,20024-250,20024-250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-50,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,50 mL,KIMAX\",869.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,50 mL,KIMAX\",UNSPSC,32039090,,20024-50,20024-50,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,20024-500,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,500 mL,KIMAX\",1065.00,H87,\"PROBETA, P.E., \"\"B\"\" ESCALA METRICA, BASE HEX. VIDRIO,  C/ BUMPER,500 mL,KIMAX\",UNSPSC,32039090,,20024-500,20024-500,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,207810-500G,\"CIANURO DE POTASIO ACS REAGENT =96.0%, 500 GR, SIGMA ALDRICH .\",6040.00,H87,\"CIANURO DE POTASIO ACS REAGENT =96.0%, 500 GR, SIGMA ALDRICH .\",UNSPSC,32169090,,207810-500G,207810-500G,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,2104-0016,\"FRASCOS DE HPDE DE BOCA ANCHA CON CALIDAD DE LABORATORIO,500ML, NALGENE™\",507.00,H87,\"FRASCOS DE HPDE DE BOCA ANCHA CON CALIDAD DE LABORATORIO,500ML, NALGENE™\",UNSPSC,32039090,,2104-0016,2104-0016,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,2204-0005,FRASCO BOCA ANGOSTA DE PP AMBAR DE 2 L MARCA NALGENE,2077.00,H87,FRASCO BOCA ANGOSTA DE PP AMBAR DE 2 L MARCA NALGENE,UNSPSC,32039090,,2204-0005,2204-0005,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,30755317-001,\"GRAFICA CIRCULAR DE 12 PULGADAS DE DIÁMETRO, TIPO TÉRMICA PARA REGISTRADOR TRULINE, CAJA CON 100 GRAFICAS.\",4283.00,H87,\"GRAFICA CIRCULAR DE 12 PULGADAS DE DIÁMETRO, TIPO TÉRMICA PARA REGISTRADOR TRULI\",UNSPSC,32039090,,30755317-001,30755317-001,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,31200-250,\"DESECADOR PARA VACIO CON TAPA  Y SALIDA LATERAL,  INCLUYE PLATO DE METAL 250 MM,250 MM,KIMAX\",12971.42,H87,\"DESECADOR PARA VACIO CON TAPA  Y SALIDA LATERAL,  INCLUYE PLATO DE METAL 250 MM,\",UNSPSC,32039090,,31200-250,31200-250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,33152-100G,\"1,5-DIPHENYLCARBAZIDE, 100G, SIGMA ALDRICH\",13703.00,H87,\"1,5-DIPHENYLCARBAZIDE, 100G, SIGMA ALDRICH\",UNSPSC,32169090,,33152-100G,33152-100G,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3818-01,\"FOSFATO DE SODIO MONOB.MONOH, CRIST.RA ACS 500 G, J.T.BAKER\",1342.00,H87,\"FOSFATO DE SODIO MONOB.MONOH, CRIST.RA ACS 500 G, J.T.BAKER\",UNSPSC,32169090,,3818-01,3818-01,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32169090\nAN01060825151,3DXZ3,\"GANCHO MAGNÉTICO, MÉTODO FIJACIÓN MAGNÉTICO, NÚMERO DE GANCHOS 1, MATERIAL DE NEODIMIO\",641.00,H87,\"GANCHO MAGNÉTICO, MÉTODO FIJACIÓN MAGNÉTICO, NÚMERO DE GANCHOS 1\",UNSPSC,32039090,,3DXZ3,3DXZ3,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,4060-12000,\"MATRAZ FLORENCIA FONDO PLANO 12 L, PYREX\",6592.00,H87,\"MATRAZ FLORENCIA FONDO PLANO 12 L, PYREX\",UNSPSC,32039090,,4060-12000,4060-12000,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,416-14,\"PINZAS DE DISECCION 14 CM SIN DIENTES, MARCA HERGOM\",164.00,H87,\"PINZAS DE DISECCION 14 CM SIN DIENTES, MARCA HERGOM\",UNSPSC,32039090,,416-14,416-14,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,45066-25150,\"TUBO DE CULTIVO ROSCADO, DECORADO  KIMAX®,  C/TAPA SIN COLOCAR  50 mL,25 X 150,KIMAX\",70.00,H87,\"TUBO DE CULTIVO ROSCADO, DECORADO  KIMAX®,  C/TAPA SIN COLOCAR  50 mL,25 X 150,K\",UNSPSC,32039090,,45066-25150,45066-25150,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,45310-50,\"TUBO NESSLER  FORMA BAJA,CAPACIDAD 50 mL,KIMAX\",788.38,H87,\"TUBO NESSLER  FORMA BAJA,CAPACIDAD 50 mL,KIMAX\",UNSPSC,32039090,,45310-50,45310-50,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,48-706-L,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PARES , TALLA GRANDE\",3462.00,XPK,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PA\",UNSPSC,32039090,,48-706-L,48-706-L,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,48-706-M,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PARES , TALLA MEDIANA\",3617.00,XPK,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PA\",UNSPSC,32039090,,48-706-M,48-706-M,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,48-706-S,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PARES , TALLA CHICA \",3617.00,XPK,\"GUANTES INDUSTRIALES RESISTENTES A CORTES DE SERVICIO MEDIANO, PAQUETE CON 12 PA\",UNSPSC,32039090,,48-706-S,48-706-S,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,750108610729,ENCENDEDOR TOKAI CON CARTUCHO,68.90,H87,ENCENDEDOR TOKAI CON CARTUCHO,UNSPSC,32039090,,750108610729,750108610729,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,3067972,CARTUCHOS DE REPUESTO TOKAI PIEZAS,40.30,H87,CARTUCHOS DE REPUESTO TOKAI PIEZAS,UNSPSC,32039090,,3067972,3067972,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,B01196WA,\"BOLSA WHIRL-PAK® 710ML./24OZ, 15 X 23CM., CON FRANJA BLANCA, ESTÉRIL, POLIETILENO TRANSPARENTE, GROSOR DE PELÍCULA 4 MILS, CAJA CON  500\",4077.97,H87,\"BOLSA WHIRL-PAK® 710ML./24OZ, 15 X 23CM. CON FRANJA BLANCA, ESTÉRIL, POLIETILENO\",UNSPSC,32039090,,B01196WA,B01196WA,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,14000-150,\"VASO PRECIP GRIFFIN, REG. F.BAJA 150ML, MARCA KIMAX\",138.96,H87,\"VASO PRECIP GRIFFIN, REG. F.BAJA 150ML, MARCA KIMAX\",UNSPSC,32039090,,14000-150,14000-150,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,26500-125,\"MATRAZ ERLENMEYER GRADUADO, BOCA REFORZADA 125 ML, KIMAX\",233.41,H87,\"MATRAZ ERLENMEYER GRADUADO, BOCA REFORZADA 125 ML, KIMAX\",UNSPSC,32039090,,26500-125,26500-125,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090\nAN01060825151,26500-250,\"MATRAZ ERLENMEYER GRADUADO, BOCA REFORZADA 250 ML, KIMAX\",270.81,H87,\"MATRAZ ERLENMEYER GRADUADO, BOCA REFORZADA 250 ML, KIMAX\",UNSPSC,32039090,,26500-250,26500-250,True,,,,90,01/01/2026,12/12/2027,,,,es_MX,eclass,32039090";


var $18bf135a870b1f2a$var$rxIsInt = /^\d+$/, $18bf135a870b1f2a$var$rxIsFloat = /^\d*\.\d+$|^\d+\.\d*$/, // If a string has leading or trailing space,
// contains a comma double quote or a newline
// it needs to be quoted in CSV output
$18bf135a870b1f2a$var$rxNeedsQuoting = /^\s|\s$|,|"|\n/, $18bf135a870b1f2a$var$isNumber = function(o) {
    return Object.prototype.toString.apply(o) === "[object Number]";
}, $18bf135a870b1f2a$var$isString = function(o) {
    return Object.prototype.toString.apply(o) === "[object String]";
}, $18bf135a870b1f2a$var$chomp = function(s) {
    if (s.charAt(s.length - 1) !== "\n") // Does not end with \n, just return string
    return s;
    // Remove the \n
    return s.substring(0, s.length - 1);
}, $18bf135a870b1f2a$var$prepField = function(field) {
    if ($18bf135a870b1f2a$var$isString(field)) {
        // Escape any " with double " ("")
        field = field.replace(/"/g, '""');
        // If the field starts or ends with whitespace, contains " or , or a newline or
        // is a string representing a number, quote it.
        if ($18bf135a870b1f2a$var$rxNeedsQuoting.test(field) || $18bf135a870b1f2a$var$rxIsInt.test(field) || $18bf135a870b1f2a$var$rxIsFloat.test(field)) field = '"' + field + '"';
        else if (field === "") field = '""';
    } else if ($18bf135a870b1f2a$var$isNumber(field)) field = field.toString(10);
    else if (field === null || field === undefined) field = "";
    else field = field.toString();
    return field;
};
const $18bf135a870b1f2a$export$cb65967a373a848f = {
    /**
     Converts an array into a Comma Separated Values string.
     Each item in the array should be an array that represents one row in the CSV.
     Nulls and undefined values are interpreted as empty fields.
  
     @method arrayToCsv
     @param {String} a The array to convert
  
     @returns {String} A CSV representation of the provided array.
     @for CSV
     @public
     @static
     @example
         var csv,
           books = [
             ['JavaScript: The Good Parts', 'Crockford, Douglas', 2008],
             ['Object-Oriented JavaScript', 'Stefanov, Stoyan', 2008],
             ['Effective JavaScript', 'Herman, David', 2012]
           ];
  
         csv = CSV.arrayToCsv(books);
  
         // csv now contains:
         //
         // JavaScript: The Good Parts,"Crockford, Douglas",2008\n
         // Object-Oriented JavaScript,"Stefanov, Stoyan",2008\n
         // Effective JavaScript,"Herman, David",2012\n
    */ arrayToCsv: function(a) {
        var cur, out = "", row, i, j;
        for(i = 0; i < a.length; i += 1){
            row = a[i];
            for(j = 0; j < row.length; j += 1){
                cur = row[j];
                cur = $18bf135a870b1f2a$var$prepField(cur);
                out += j < row.length - 1 ? cur + "," : cur;
            }
            // End record
            out += "\n";
        }
        return out;
    },
    /**
      Converts a Comma Separated Values string into a multi-dimensional array.
      Each row in the CSV becomes an array.
      Empty fields are converted to nulls and non-quoted numbers are converted to integers or floats.
  
      @method csvToArray
      @return {Array} The CSV parsed as an array
      @param {String} s The string to convert
      @param {Object} [config] Object literal with extra configuration. For historical reasons setting config to `true` is the same as passing `{trim: true}`, but this usage is deprecated and will likely be removed in the next version.
      @param {Boolean} [config.trim=false] If set to True leading and trailing whitespace is stripped off of each non-quoted field as it is imported
      @for CSV
      @static
      @example
          var books,
            csv = 'JavaScript: The Good Parts,"Crockford, Douglas",2008\n' +
              'Object-Oriented JavaScript,"Stefanov, Stoyan",2008\n' +
              'Effective JavaScript,"Herman, David",2012\n';
  
          books = CSV.csvToArray(csv);
  
          // books now equals:
          // [
          //   ['JavaScript: The Good Parts', 'Crockford, Douglas', 2008],
          //   ['Object-Oriented JavaScript', 'Stefanov, Stoyan', 2008],
          //   ['Effective JavaScript', 'Herman, David', 2012]
          // ];
    */ csvToArray: function(s, config) {
        // Get rid of any trailing \n
        s = $18bf135a870b1f2a$var$chomp(s);
        if (config === true) config = {
            trim: true
        };
        else config = config || {};
        var cur = "", inQuote = false, fieldQuoted = false, field = "", row = [], out = [], trimIt = config.trim === true ? true : false, i, processField = function(field) {
            var trimmedField = field.trim();
            if (fieldQuoted !== true) {
                // If field is empty set to null
                if (field === "") field = null;
                else if (trimIt === true) field = trimmedField;
                // Convert unquoted numbers to numbers
                if ($18bf135a870b1f2a$var$rxIsInt.test(trimmedField) || $18bf135a870b1f2a$var$rxIsFloat.test(trimmedField)) field = +trimmedField;
            }
            return field;
        };
        for(i = 0; i < s.length; i += 1){
            cur = s.charAt(i);
            // If we are at a EOF or EOR
            if (inQuote === false && (cur === "," || cur === "\n")) {
                field = processField(field);
                // Add the current field to the current row
                row.push(field);
                // If this is EOR append row to output and flush row
                if (cur === "\n") {
                    out.push(row);
                    row = [];
                }
                // Flush the field buffer
                field = "";
                fieldQuoted = false;
            } else // If it's not a ", add it to the field buffer
            if (cur !== '"') field += cur;
            else {
                if (!inQuote) {
                    // We are not in a quote, start a quote
                    inQuote = true;
                    fieldQuoted = true;
                } else // Next char is ", this is an escaped "
                if (s.charAt(i + 1) === '"') {
                    field += '"';
                    // Skip the next char
                    i += 1;
                } else // It's not escaping, so end quote
                inQuote = false;
            }
        }
        // Add the last field
        field = processField(field);
        row.push(field);
        out.push(row);
        return out;
    },
    /**
      Converts a Comma Separated Values string into an array of objects.
      Each row in the CSV becomes an object with properties named after each column.
      Empty fields are converted to nulls and non-quoted numbers are converted to integers or floats.
  
      @method csvToObject
      @since 1.2.0
      @return {Array} The CSV parsed as an array of objects
      @param {String} s The string containing CSV data to convert
      @param {Object} config Object literal with extra configuration
      @param {Array} [config.columns] An array containing the name of each column in the CSV data. If not
        provided, the first row of the CSV data is assumed to contain the column names.
      @param {Boolean} [config.trim] If true any field parsed from the CSV data will have leading and
                                     trailing whitespace trimmed
      @for CSV
      @static
      @example
          var books,
            csv = 'title,author,year\n' +
              'JavaScript: The Good Parts,"Crockford, Douglas",2008\n' +
              'Object-Oriented JavaScript,"Stefanov, Stoyan",2008\n' +
              'Effective JavaScript,"Herman, David",2012\n';
  
          books = CSV.csvToObject(csv);
  
          // books now equals:
          // [
          //   {
          //     title: 'JavaScript: The Good Parts',
          //     author: 'Crockford, Douglas',
          //     year: 2008
          //   },
          //   {
          //     title: 'Object-Oriented JavaScript',
          //     author: 'Stefanov, Stoyan',
          //     year: 2008
          //   },
          //   {
          //     title: 'Effective JavaScript',
          //     author: 'Herman, David',
          //     year: 2012
          //   }
          // ];
    */ csvToObject: function(s, config) {
        config = config !== undefined ? config : {};
        var columns = config.columns, trimIt = !!config.trim, csvArray = this.csvToArray(s, trimIt);
        // if columns were not provided, assume they are
        // in the first row
        if (!columns) columns = csvArray.shift();
        columns = columns.map((it)=>(it || "").replace('"', "").trim());
        return csvArray.map(function(row) {
            var obj = {}, i = 0, len = columns.length;
            for(; i < len; i += 1)obj[columns[i]] = row[i];
            return obj;
        });
    },
    /**
      Converts an array of objects into Comma Separated Values data
      Each propery on the objects becomes a column in the CSV data.
  
      @method objectToCsv
      @since 1.2.0
      @return {String} CSV data, each row representing an object from the input array, each field representing a property from those objects
      @param {String} arr An array of objects to be converted into CSV
      @param {Object} config Object literal with extra configuration
      @param {Array} [config.columns] An array containing the name of each column in the CSV data. If not
        provided, the column names will be inferred from the property names of the objects. Explicitly
        defining column names has several advantages:
  
        * It is faster since all column names are already known.
        * It allows you to specify a subset of the properties to use if you wish to.
        * It allows you to control what order the columns are output in, since the `for...in` statement used to infer field names does not guarantee a specific order.
  
      @param {Boolean} [config.includeColumns=true] By default `objectToCsv` outputs the column names as
        the first row of the CSV data. Set to false to prevent this.
      @for CSV
      @static
      @example
          var csv,
            books = [
              {
                title: 'JavaScript: The Good Parts',
                author: 'Crockford, Douglas',
                year: 2008
              },
              {
                title: 'Object-Oriented JavaScript',
                author: 'Stefanov, Stoyan',
                year: 2008
              },
              {
                title: 'Effective JavaScript',
                author: 'Herman, David',
                year: 2012
              }
            ];
  
          csv = CSV.objectToCsv(books);
  
          // csv now contains:
          //
          // title,author,year\n
          // JavaScript: The Good Parts,"Crockford, Douglas",2008\n
          // Object-Oriented JavaScript,"Stefanov, Stoyan",2008\n
          // Effective JavaScript,"Herman, David",2012\n
    */ objectToCsv: function(arr, config) {
        config = config !== undefined ? config : {};
        var columns = config.columns, includeColumns = config.includeColumns, csv = "", csvColumns = "", processKnownColumns = function(obj) {
            var out = "", prop, i, len = arr.length, j, jlen = columns.length;
            for(i = 0; i < len; i += 1){
                obj = arr[i];
                for(j = 0; j < jlen; j += 1){
                    prop = columns[j];
                    out += $18bf135a870b1f2a$var$prepField(obj[prop]);
                    out += j < jlen - 1 ? "," : "";
                }
                out += "\n";
            }
            return out;
        }, processUnknownColumns = function() {
            var cols = [], firstRowLength, finalRowLength, obj, prop, i, currentCol, len = arr.length, row, out = [];
            for(i = 0; i < len; i += 1){
                obj = arr[i];
                row = [];
                // loop over all props in obj,
                for(prop in obj)if (obj.hasOwnProperty(prop)) {
                    currentCol = cols.indexOf(prop);
                    // if this prop does not have a column yet
                    if (currentCol === -1) {
                        currentCol = cols.push(prop);
                        currentCol -= 1;
                    }
                    row[currentCol] = $18bf135a870b1f2a$var$prepField(obj[prop]);
                }
                if (i === 0) firstRowLength = row.length;
                out.push(row);
            }
            finalRowLength = cols.length;
            // if some objects had properties that weren't on all the object
            // we need to resize each row.
            if (firstRowLength !== finalRowLength) out.forEach(function(row) {
                row.length = finalRowLength;
            });
            // export cols to our parent scope so
            // includeColumns can use it
            columns = cols;
            return out.map(function(row) {
                return row.join(",");
            }).join("\n") + "\n";
        };
        includeColumns = includeColumns === undefined ? true : !!includeColumns;
        if (columns !== undefined) csv = processKnownColumns();
        else csv = processUnknownColumns();
        if (includeColumns) {
            columns.forEach(function(col) {
                csvColumns += $18bf135a870b1f2a$var$prepField(col) + ",";
            });
            csvColumns = csvColumns.substring(0, csvColumns.length - 1);
            csv = csvColumns + "\n" + csv;
        }
        return csv;
    }
};


let $50857ca7dedf904b$var$params = new URL(window.location.href).searchParams;
let $50857ca7dedf904b$export$f4f21ed02b0ddb8f = "MXN";
console.log((0, (/*@__PURE__*/$parcel$interopDefault($ec47c5424ac040c3$exports))));
console.log((0, $18bf135a870b1f2a$export$cb65967a373a848f).csvToObject((0, (/*@__PURE__*/$parcel$interopDefault($ec47c5424ac040c3$exports)))));
const $50857ca7dedf904b$export$f74b06b2a4ca50e9 = (0, $18bf135a870b1f2a$export$cb65967a373a848f).csvToObject((0, (/*@__PURE__*/$parcel$interopDefault($ec47c5424ac040c3$exports))))// filter out products without SKU
.filter((product)=>{
    const sku = product["Supplier Part ID"];
    return sku != null && String(sku).trim() !== "";
}).map((product)=>{
    console.log(product);
    return {
        sku: product["Supplier Part ID"].toString(),
        image: "/assets/images/" + $50857ca7dedf904b$export$95172451bb18dda2(product["Image-1"]?.toString().replace(/\s+/g, "")),
        name: product["Item Description"].toString(),
        description: product["Item Description"].toString(),
        price: parseFloat(product["Unit Price"]?.toString()),
        category: [
            product.Group
        ].filter((it)=>it).join("/"),
        unit: (product["Unit of Measure"] || "EA").toUpperCase(),
        unspsc: product["Classification Codes-1"]?.toString(),
        currency: $50857ca7dedf904b$export$f4f21ed02b0ddb8f,
        data: product
    };
}).filter((it)=>{
    it.price;
    return it.price > 0;
});
function $50857ca7dedf904b$export$95172451bb18dda2(img) {
    if (!img) return img;
    if (img.toLowerCase().endsWith(".jpg")) return img;
    return img + ".jpg";
}
function $50857ca7dedf904b$export$9068818d4d1af46a(currency) {
    return ({
        "USD": "$",
        "EUR": "\u20AC",
        "MXN": "MX$"
    })[currency] || currency;
}
class $50857ca7dedf904b$export$494d083da011ade5 {
    constructor(){
        this.items = [];
    }
}
class $50857ca7dedf904b$export$a1edc412be3e1841 {
    constructor(){
        this.cartClass = "";
        this.search = "";
        this.filter = {};
        this.products = $50857ca7dedf904b$export$f74b06b2a4ca50e9;
        this.cart = new $50857ca7dedf904b$export$494d083da011ade5();
        if (localStorage.getItem("cart")) this.cart = JSON.parse(localStorage.getItem("cart"));
    }
}
let $50857ca7dedf904b$var$fuse = new (0, $33893b708b33402d$export$2e2bcd8739ae039)([]);
function $50857ca7dedf904b$export$39fd934b9ffc5669(state, action) {
    console.log(action);
    switch(action.type){
        case "cart.clear":
            state.cart.items = [];
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "filter.clear":
            state.search = "";
            state.filter = {};
            break;
        case "search":
            state.search = action.value;
            break;
        case "add":
            const id = $50857ca7dedf904b$var$hash([
                action.product.sku,
                action.options
            ]);
            const item = state.cart.items.find((it)=>it.id == id);
            if (item) item.quantity += action.quantity;
            else state.cart.items.push({
                ...action,
                id: id
            });
            state.cartClass = "animate__animated animate__headShake";
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "quantity":
            // update quantity
            state.cart.items.filter((it)=>it.id == action.id).forEach((it)=>it.quantity = action.quantity);
            // remove if quantity is 0
            state.cart.items = state.cart.items.filter((it)=>it.quantity);
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "products":
            state.products = [
                ...action.products
            ];
            $50857ca7dedf904b$var$fuse = new (0, $33893b708b33402d$export$2e2bcd8739ae039)(state.products, {
                keys: [
                    "name",
                    "sku",
                    "description"
                ],
                findAllMatches: true,
                threshold: 0.4
            });
            break;
        case "filter":
            state.filter = action.filter;
            break;
        case "filter.in":
            state.filter[action.key] = state.filter[action.key] || [];
            if (action.value) state.filter[action.key].push(action.option);
            else state.filter[action.key] = state.filter[action.key].filter((it)=>it !== action.option);
            if (state.filter[action.key].length == 0) delete state.filter[action.key];
            break;
        case "endanimate":
            state.cartClass = "";
            break;
        default:
            break;
    }
    return {
        ...state
    };
}
function $50857ca7dedf904b$export$d76128d007d19019(state) {
    let products = state.products;
    if (state.search) products = $50857ca7dedf904b$var$fuse.search(state.search).map((it)=>it.item);
    return products.filter((product)=>{
        for(const key in state.filter){
            const value = state.filter[key];
            if (value == undefined) continue;
            else if (Array.isArray(value)) {
                if (value.includes(product[key])) continue;
            } else if (value == product[key]) continue;
            return false;
        }
        return true;
    });
}
const $50857ca7dedf904b$var$hash = (str)=>{
    if (typeof str !== "string") str = JSON.stringify(str);
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};





async function $95736dcca94d7cd5$export$113d76473aa08eea(data) {
    const res = await (await fetch("https://punchout.cloud/cart/" + localStorage.getItem("punchout_id"), {
        body: JSON.stringify({
            cart: {
                Catalog: data
            },
            custom: {}
        }),
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })).text();
    try {
        return JSON.parse(res);
    } catch (e) {
        throw new Error(res);
    }
}
class $95736dcca94d7cd5$var$Punchout {
    async submitCart(cart) {
        try {
            this.showBlock();
            const res = await $95736dcca94d7cd5$export$113d76473aa08eea(cart);
            if (!res.url || !res.data) {
                alert(res.message || "An error happened with punchout");
                this.hideBlock();
                return;
            }
            const form = this.createPunchoutForm(res);
            localStorage.clear();
            form.submit();
            form.onerror = ()=>this.hideBlock();
            form.onsubmit = ()=>localStorage.removeItem("punchoutSessionId");
        } catch (error) {
            console.log("ERROR", error);
            alert(error.message);
            this.hideBlock();
        }
    }
    createPunchoutForm({ data_array: data_array, data: data, url: url }) {
        const form = document.createElement("form");
        form.setAttribute("hidden", "true");
        form.setAttribute("method", "POST");
        form.setAttribute("action", url);
        if (data_array.length) data_array.forEach(({ key: key, value: value })=>{
            const input1 = document.createElement("input");
            input1.setAttribute("type", "text");
            input1.setAttribute("name", key);
            input1.setAttribute("value", value);
            form.appendChild(input1);
        });
        else for(const key in data){
            const input = document.createElement("input");
            input.setAttribute("type", "text");
            input.setAttribute("name", key);
            input.setAttribute("value", data[key]);
            form.appendChild(input);
        }
        document.body.appendChild(form);
        return form;
    }
    showBlock() {
        this._block = this._block || this.createBlock();
        document.body.appendChild(this._block);
    }
    hideBlock() {
        this._block = this._block || this.createBlock();
        document.body.removeChild(this._block);
    }
    createBlock() {
        const block = document.createElement("div");
        block.classList.add("punchout-block");
        const loading = document.createElement("div");
        loading.classList.add("punchout-loading");
        loading.appendChild(document.createElement("div"));
        loading.appendChild(document.createElement("div"));
        block.appendChild(loading);
        return block;
    }
}
const $95736dcca94d7cd5$export$c45398cde961fa4a = new $95736dcca94d7cd5$var$Punchout();
function $95736dcca94d7cd5$export$21a94553ffa41578({ punchout_id: punchout_id }) {
    const { state: state, dispatch: dispatch } = (0, $543d6d2a56ed7d8d$export$39f92e86d1722f3a)();
    localStorage.setItem("punchout_id", punchout_id);
    dispatch({
        type: "cart.clear"
    });
    dispatch({
        type: "filter.clear"
    });
    (0, $044786338e0e8fe2$export$4cb887bfde2d34ca)("/");
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)``;
}


const $543d6d2a56ed7d8d$export$a3a6a28ae8823b06 = new (0, $50857ca7dedf904b$export$a1edc412be3e1841)();
const $543d6d2a56ed7d8d$var$StoreContext = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)({
    state: $543d6d2a56ed7d8d$export$a3a6a28ae8823b06,
    dispatch: (action)=>{}
});
const $543d6d2a56ed7d8d$export$39f92e86d1722f3a = ()=>(0, $204a33a7557cbbd0$export$fae74005e78b1a27)($543d6d2a56ed7d8d$var$StoreContext);
const $543d6d2a56ed7d8d$var$punchoutId = window.location.search.substring(1).split("&").map((pair)=>pair.split("=")).reduce((p, n)=>{
    p[n[0]] = decodeURIComponent(n[1]);
    return p;
}, {}).punchout || localStorage.getItem("punchoutId");
if ($543d6d2a56ed7d8d$var$punchoutId) localStorage.setItem("punchoutId", $543d6d2a56ed7d8d$var$punchoutId);
function $543d6d2a56ed7d8d$var$App() {
    const [state, dispatch] = (0, $204a33a7557cbbd0$export$13e3392192263954)((0, $50857ca7dedf904b$export$39fd934b9ffc5669), $543d6d2a56ed7d8d$export$a3a6a28ae8823b06);
    const store = {
        state: state,
        dispatch: dispatch
    };
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        dispatch({
            type: "products",
            products: (0, $50857ca7dedf904b$export$f74b06b2a4ca50e9)
        });
    }, []);
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<${$543d6d2a56ed7d8d$var$StoreContext.Provider} value=${store}>
    <${$543d6d2a56ed7d8d$var$Header}></${$543d6d2a56ed7d8d$var$Header}>

    <${0, $044786338e0e8fe2$export$55185c17a0fcbe46}>
        <${$543d6d2a56ed7d8d$var$Main} default />
        <${$543d6d2a56ed7d8d$var$CartView} path="/cart" />
        <${$543d6d2a56ed7d8d$var$ProductDetail} path="/p/:sku" />
        <${0, $95736dcca94d7cd5$export$21a94553ffa41578} path="/login/:punchout_id" />
    </${0, $044786338e0e8fe2$export$55185c17a0fcbe46}>
</${$543d6d2a56ed7d8d$var$StoreContext.Provider}>`;
}
function $543d6d2a56ed7d8d$var$Main() {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="app-content content ecommerce-application">

        <${$543d6d2a56ed7d8d$var$Content}></${$543d6d2a56ed7d8d$var$Content}>

</div>`;
}
function $543d6d2a56ed7d8d$var$Sidebar() {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const brands = Object.keys(state.products.reduce((p, n)=>{
        p[n.brand] = true;
        return p;
    }, {}));
    const categories = Object.keys(state.products.reduce((p, n)=>{
        p[n.category] = true;
        return p;
    }, {}));
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="sidebar-detached sidebar-left">
    <div class="sidebar">
        <!-- Ecommerce Sidebar Starts -->
        <div class="sidebar-shop">
            <div class="row">
                <div class="col-sm-12">
                    <h6 class="filter-heading d-none d-lg-block">Filters</h6>
                </div>
            </div>
            <div class="card pt-0">
                <div class="card-body">
                    <!-- Price Filter starts -
                    <div class="multi-range-price">
                        <h6 class="filter-title mt-0">Multi Range</h6>
                        <ul class="list-unstyled price-range" id="price-range">
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceAll" name="price-range" class="form-check-input"
                                        checked="" />
                                    <label class="form-check-label" for="priceAll">All</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange1" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange1">&lt;=$10</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange2" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange2">$10 - $100</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceARange3" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceARange3">$100 - $500</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange4" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange4">&gt;= $500</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Price Filter ends -->

                    <!-- Price Slider starts 
                    <div class="price-slider">
                        <h6 class="filter-title">Price Range</h6>
                        <div class="price-slider">
                            <div class="range-slider mt-2 noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr"
                                id="price-slider">
                                <div class="noUi-base">
                                    <div class="noUi-connects">
                                        <div class="noUi-connect"
                                            style="transform: translate(29.2786%, 0px) scale(0.404122, 1);">
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-707.214%, 0px); z-index: 5;">
                                        <div class="noUi-handle noUi-handle-lower" data-handle="0" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="51.0"
                                            aria-valuemax="3500.0" aria-valuenow="1500.0" aria-valuetext="1500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">1500</div>
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-303.092%, 0px); z-index: 4;">
                                        <div class="noUi-handle noUi-handle-upper" data-handle="1" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="1500.0"
                                            aria-valuemax="5000.0" aria-valuenow="3500.0" aria-valuetext="3500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">3500</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Price Range ends -->
                    <div id="clear-filters">
                        <button onclick=${()=>dispatch({
            type: "filter.clear"
        })} type="button" class="btn w-100 btn-primary waves-effect waves-float waves-light">Clear
                            All Filters</button>
                    </div>
                    <!-- Categories Starts -->
                    <div id="product-categories">
                        <h6 class="filter-title">Categories</h6>
                        <ul class="list-unstyled categories-list">
                        <li onclick=${(ev)=>dispatch({
            type: "filter",
            filter: {
                ...state.filter,
                category: undefined
            }
        })}>
                                <div class="form-check"  >
                                    <input type="radio" id="category-all" name="category-filter" class="form-check-input"
                                        checked=${state.filter.category == undefined} />
                                    <label class="form-check-label" for="category1">All</label>
                                </div>
                            </li>
                            ${categories.map((category)=>(0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<li onclick=${(ev)=>dispatch({
                type: "filter",
                filter: {
                    ...state.filter,
                    category: category
                }
            })}>
                                <div class="form-check"  >
                                    <input type="radio" id="category-${category}" name="category-filter" class="form-check-input"
                                        checked=${state.filter.category == category} />
                                    <label class="form-check-label" for="category1">${category}</label>
                                </div>
                            </li>`)}
                        </ul>
                    </div>
                    <!-- Categories Ends -->

                    <!-- Brands starts -->
                    <div class="brands">
                        <h6 class="filter-title">Brands</h6>
                        <ul class="list-unstyled brand-list">
                            ${brands.map((brand, index)=>(0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`
                            <li>
                                <div class="form-check">
                                    <input  onchange=${(ev)=>dispatch({
                type: "filter.in",
                key: "brand",
                option: brand,
                value: ev.target.checked
            })} type="checkbox" class="form-check-input" id="productBrand${index}" />
                                    <label class="form-check-label" for="productBrand${index}">${brand}</label>
                                </div>
                                <span></span>
                            </li>`)}
                        </ul>
                    </div>
                    <!-- Brand ends -->

                    <!-- Clear Filters Starts -->
                    
                    <!-- Clear Filters Ends -->
                </div>
            </div>
        </div>
        <!-- Ecommerce Sidebar Ends -->

    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$Content() {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const products = (0, $50857ca7dedf904b$export$d76128d007d19019)(state);
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="content-detached ">
    <div class="content-body">
        <!-- E-commerce Content Section Starts -->
        <section id="ecommerce-header">
            <div class="row">
                <div class="col-sm-12">
                    <div class="ecommerce-header-items">
                        <div class="result-toggler">
                            <button class="navbar-toggler shop-sidebar-toggler" type="button" data-bs-toggle="collapse">
                                <span class="navbar-toggler-icon d-block d-lg-none"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-menu">
                                        <line x1="3" y1="12" x2="21" y2="12"></line>
                                        <line x1="3" y1="6" x2="21" y2="6"></line>
                                        <line x1="3" y1="18" x2="21" y2="18"></line>
                                    </svg></span>
                            </button>
                            <div class="search-results">${products.length} results found</div>
                        </div>
                        <div class="view-options d-flex">
                            <!--
                            <div class="btn-group dropdown-sort">
                                <button type="button" class="btn btn-outline-primary dropdown-toggle me-1 waves-effect"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="active-sorting">Featured</span>
                                </button>
                                <div class="dropdown-menu" style="">
                                    <a class="dropdown-item" href="#">Featured</a>
                                    <a class="dropdown-item" href="#">Lowest</a>
                                    <a class="dropdown-item" href="#">Highest</a>
                                </div>
                            </div>
                            <div class="btn-group" role="group">
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option1"
                                    autocomplete="off" checked="" />
                                <label class="btn btn-icon btn-outline-primary view-btn grid-view-btn waves-effect"
                                    for="radio_option1"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-grid font-medium-3">
                                        <rect x="3" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="14" width="7" height="7"></rect>
                                        <rect x="3" y="14" width="7" height="7"></rect>
                                    </svg></label>
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option2"
                                    autocomplete="off" />
                                <label class="btn btn-icon btn-outline-primary view-btn list-view-btn waves-effect"
                                    for="radio_option2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-list font-medium-3">
                                        <line x1="8" y1="6" x2="21" y2="6"></line>
                                        <line x1="8" y1="12" x2="21" y2="12"></line>
                                        <line x1="8" y1="18" x2="21" y2="18"></line>
                                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                                    </svg></label>
                            </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- E-commerce Content Section Starts -->

        <!-- background Overlay when sidebar is shown  starts-->
        <div class="body-content-overlay"></div>
        <!-- background Overlay when sidebar is shown  ends-->

        <!-- E-commerce Search Bar Starts -->
        <section id="ecommerce-searchbar" class="ecommerce-searchbar">
            <div class="row mt-1">
                <div class="col-sm-12">
                    <div class="input-group input-group-merge">
                        <input value=${state.search} onkeyup=${(ev)=>dispatch({
            type: "search",
            value: ev.target.value
        })} type="text" class="form-control search-product" id="shop-search"
                            placeholder="Search Product" aria-label="Search..." aria-describedby="shop-search" />
                        <span class="input-group-text"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-search text-muted">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg></span>
                    </div>
                </div>

            </div>
        </section>
        <!-- E-commerce Search Bar Ends -->

        <!-- E-commerce Products Starts -->
        <section id="ecommerce-products" class="grid-view">
            ${products.map($543d6d2a56ed7d8d$var$ProductCart)}
        </section>
        <!-- E-commerce Products Ends -->

        <!-- E-commerce Pagination Starts
        <section id="ecommerce-pagination">
            <div class="row">
                <div class="col-sm-12">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center mt-2">
                            <li class="page-item prev-item"><a class="page-link" href="#"></a></li>
                            <li class="page-item active"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                            <li class="page-item" aria-current="page"><a class="page-link" href="#">4</a></li>
                            <li class="page-item"><a class="page-link" href="#">5</a></li>
                            <li class="page-item"><a class="page-link" href="#">6</a></li>
                            <li class="page-item"><a class="page-link" href="#">7</a></li>
                            <li class="page-item next-item"><a class="page-link" href="#"></a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section> -->
        <!-- E-commerce Pagination Ends -->

    </div>
</div>`;
}

function $543d6d2a56ed7d8d$var$Header() {
    const { state: state } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<nav class="header-navbar navbar-expand-lg navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center"
    data-nav="brand-center">
    <div class="navbar-header d-xl-block d-none">
        <ul class="nav navbar-nav">
            <li class="nav-item"><a class="navbar-brand"
                    href="/"><span class="brand-logo">
                    </span>
                    <img src=${(parcelRequire("1bT83"))} alt="logo" height="60px" style="width:auto;height:91px;"  />
                </a></li>
        </ul>
    </div>
    <div class="navbar-container d-flex content">

        <ul class="nav navbar-nav align-items-center ms-auto">



            <li class="nav-item dropdown dropdown-cart me-25">
                <a class="nav-link ${state.cartClass}" href="/cart"
                    data-bs-toggle="dropdown"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="feather feather-shopping-cart ficon">
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg><span
                        class="badge rounded-pill bg-primary badge-up cart-item-count">${state.cart.items.reduce((p, n)=>p + n.quantity, 0)}</span></a>

            </li>


        </ul>
    </div>
</nav>`;
}
function $543d6d2a56ed7d8d$var$ProductCart(product) {
    const { dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="card ecommerce-card">
    <div class="item-img text-center">
        <a href="/p/${encodeURI(product.sku).replace(/#/g, "%23")}">
            <img class="img-fluid card-img-top" src=${product.image} alt="img-placeholder" /></a>
    </div>
    <div class="card-body">
        <div class="item-wrapper">
            <div>
                <h6 class="item-price">${(0, $50857ca7dedf904b$export$9068818d4d1af46a)(product.currency)}${product.price?.toFixed(2)}</h6>
            </div>
        </div>
        <h6 class="item-name">
            <a class="text-body" href="/p/${encodeURI(product.sku).replace(/#/g, "%23")}">${product.name}</a>
            <span class="card-text item-company">By <a href="#" class="company-name">${product.brand}</a></span>
        </h6>
        <p class="card-text item-description">${product.description}</p>
    </div>
    <div class="item-options text-center">
        <div class="item-wrapper">
            <div class="item-cost">
                <h4 class="item-price">${(0, $50857ca7dedf904b$export$9068818d4d1af46a)(product.currency)}${product.price}</h4>
            </div>
        </div>
        <${$543d6d2a56ed7d8d$var$AddToCartBtn} product=${product}></${$543d6d2a56ed7d8d$var$AddToCartBtn}>
    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$AddToCartBtn({ product: product }) {
    const { dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<a onclick=${()=>{
        dispatch({
            type: "add",
            product: product,
            quantity: 1,
            options: {}
        });
        setTimeout(()=>dispatch({
                type: "endanimate"
            }), 700);
    }} class="btn btn-primary btn-cart waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
    <span class="add-to-cart">Add to cart</span>
</a>`;
}
function $543d6d2a56ed7d8d$var$WhishlistBtn() {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<a href="#" class="btn btn-light btn-wishlist waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
        <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
        </path>
    </svg>
    <span>Wishlist</span>
</a>`;
}
function $543d6d2a56ed7d8d$var$CartView() {
    const { state: state } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const onPunchoutClick = ()=>{
        if (!localStorage.getItem("punchout_id")) return alert("You are not in a punchout session. Please start a session from your procurement system.");
        (0, $95736dcca94d7cd5$export$c45398cde961fa4a).submitCart({
            items: state.cart.items.map((it)=>({
                    ...it,
                    product: {
                        ...it.product,
                        price: Math.round(it.product.price * 100)
                    }
                })),
            currency: $50857ca7dedf904b$export$f4f21ed02b0ddb8f
        }).then(()=>{});
    };
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="app-content content ecommerce-application">
        <div class="content-wrapper container-xxl p-0">
        <div class="content-body">
    <div class="bs-stepper checkout-tab-steps">
        <div class="bs-stepper-content">
            <!-- Checkout Place order starts -->
            <div id="step-cart" class="content active dstepper-block" role="tabpanel" aria-labelledby="step-cart-trigger">
                <div id="place-order" class="list-view product-checkout">
                    <!-- Checkout Place Order Left starts -->
                    <div class="checkout-items">
                        ${state.cart.items.map($543d6d2a56ed7d8d$var$CartItemView)}

                    </div>
                    <!-- Checkout Place Order Left ends -->

                    <!-- Checkout Place Order Right starts -->
                    <div class="checkout-options">
                        <div class="card">
                            <div class="card-body">
                                <!--
                                <label class="section-label form-label mb-1">Options</label>
                                <div class="coupons input-group input-group-merge">
                                    <input type="text" class="form-control" placeholder="Coupons" aria-label="Coupons" aria-describedby="input-coupons"/>
                                    <span class="input-group-text text-primary ps-1" id="input-coupons">Apply</span>
                                </div>
                                <hr/>
-->
                                <div class="price-details">
                                    <!--
                                    <h6 class="price-title">Price Details</h6>
                                    <ul class="list-unstyled">
                                        <li class="price-detail">
                                            <div class="detail-title">Total MRP</div>
                                            <div class="detail-amt">$598</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Bag Discount</div>
                                            <div class="detail-amt discount-amt text-success">-25$</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Estimated Tax</div>
                                            <div class="detail-amt">$1.3</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">EMI Eligibility</div>
                                            <a href="#" class="detail-amt text-primary">Details</a>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Delivery Charges</div>
                                            <div class="detail-amt discount-amt text-success">Free</div>
                                        </li>
                                    </ul>
                                    <hr/>
-->
                                    <ul class="list-unstyled">
                                        <li class="price-detail">
                                            <div class="detail-title detail-total">Total</div>
                                            <div class="detail-amt fw-bolder">${(0, $50857ca7dedf904b$export$9068818d4d1af46a)((0, $50857ca7dedf904b$export$f4f21ed02b0ddb8f))}${state.cart.items.reduce((p, n)=>p + n.product.price * n.quantity, 0).toFixed(2)}</div>
                                        </li>
                                    </ul>
                                    <button onclick=${(ev)=>{
        ev.preventDefault();
        onPunchoutClick();
    }} type="button" class="btn btn-primary w-100 btn-next place-order waves-effect waves-float waves-light">Punchout</button>
                                </div>
                            </div>
                        </div>
                        <!-- Checkout Place Order Right ends -->
                    </div>
                </div>
                <!-- Checkout Place order Ends -->
            </div>

        </div>
    </div>
        </div>
    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$CartItemView(item) {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="card ecommerce-card">
                            <div class="item-img">
                                <a href="app-ecommerce-details.html">
                                    <img src=${item.product.image} alt="img-placeholder"/>
                                </a>
                            </div>
                            <div class="card-body">
                                <div class="item-name">
                                    <h6 class="mb-0"><a href="app-ecommerce-details.html" class="text-body">${item.product.name}</a></h6>
                                    <span class="item-company">By <a href="#" class="company-name">${item.product.brand}</a></span>
                                </div>
                                <span class="text-success mb-1">In stock - Except sales</span>
                                <div class="item-quantity">
                                    <span class="quantity-title">Qty:</span>
                                    <div class="quantity-counter-wrapper">
                                        <div class="input-group bootstrap-touchspin">
                                            <span class="input-group-btn bootstrap-touchspin-injected">
                                                <button onclick=${()=>dispatch({
            type: "quantity",
            id: item.id,
            quantity: item.quantity - 1
        })} class="btn btn-primary bootstrap-touchspin-down" type="button">-</button>
                                            </span>
                                            <input onkeyup=${(ev)=>dispatch({
            type: "quantity",
            id: item.id,
            quantity: parseInt(ev.target.value)
        })} value=${item.quantity} type="number" class="quantity-counter form-control"/>
                                            <span onclick=${()=>dispatch({
            type: "quantity",
            id: item.id,
            quantity: item.quantity + 1
        })} class="input-group-btn bootstrap-touchspin-injected">
                                                <button class="btn btn-primary bootstrap-touchspin-up" type="button">+</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-options text-center">
                                <div class="item-wrapper">
                                    <div class="item-cost">
                                        <h4 class="item-price">${(0, $50857ca7dedf904b$export$9068818d4d1af46a)(item.product.currency)}${item.product.price.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <button onclick=${()=>dispatch({
            type: "quantity",
            id: item.id,
            quantity: 0
        })}  type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x align-middle me-25"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    <span>Remove</span>
                                </button>
                            </div>
                        </div>`;
}
function $543d6d2a56ed7d8d$var$ProductPreview(product, addToCart) {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div>${product.name} :${product.price}

    <button onclick=${(ev)=>addToCart(product, 1)}>Add to cart</button>
</div>`;
}
function $543d6d2a56ed7d8d$var$Product({ productId: productId }) {}
function $543d6d2a56ed7d8d$var$ProductDetail({ sku: sku }) {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const product = state.products.find((it)=>it.sku == sku);
    console.log(product);
    if (product) return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="content-wrapper container-xxl p-0 animate__animated animate__fadeIn">
    
    <div class="content-body">
    <!-- app e-commerce details start -->
    <section class="app-ecommerce-details">
        <div class="card">
            <!-- Product Details starts -->
            <div class="card-body">
                <div class="row my-2">
                    <div class="col-12 col-md-5 d-flex align-items-center justify-content-center mb-2 mb-md-0">
                        <div class="d-flex align-items-center justify-content-center">
                            <img src=${product.image} class="img-fluid product-img" alt="product image"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-7">
                        <h4>${product.name}</h4>
                        <span class="card-text item-company">By <a href="#" class="company-name">${product.brand}</a></span>
                        <div class="ecommerce-details-price d-flex flex-wrap mt-1">
                            <h4 class="item-price me-1">${(0, $50857ca7dedf904b$export$9068818d4d1af46a)(product.currency)}${product.price}</h4>
                            <!--
                            <ul class="unstyled-list list-inline ps-1 border-start">
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star unfilled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                            </ul>
    -->
                        </div>
                        <p class="card-text">Available - <span class="text-success">In stock - Except sales</span></p>
                        <p class="card-text">
                            ${product.description}
                        </p>
                        <!--
                        <ul class="product-features list-unstyled">
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> <span>Free Shipping</span></li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                                <span>EMI options available</span>
                            </li>
                        </ul>
    -->
                        <hr/>
                        ${Object.keys(product.data).filter((key)=>[
            "Supplier ID",
            "Supplier Part ID",
            "Classification Codes-1",
            "Unit of Measure"
        ].indexOf(key) > -1).map((key)=>{
        const data = product.data[key];
        let label = key;
        return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="product-color-options" style="display:flex;">
                            <h6 style="flex: 1 0;">${label}</h6>
                            <span style="flex: 0 1 80%;">${data}</span>
                        </div><hr style="margin: 3px;"/>`;
    })}
            <div class="product-color-options" style="display:flex;">
                            <h6 style="flex: 1 0;">Una vez recibida su orden de compra, se confirma fecha de entrega</h6>
                        </div>
                        <hr/>
                        <div class="d-flex flex-column flex-sm-row pt-1">
                            <a onclick=${()=>dispatch({
            type: "add",
            product: product,
            quantity: 1,
            options: {}
        })} class="btn btn-primary btn-cart me-0 me-sm-1 mb-1 mb-sm-0 waves-effect waves-float waves-light">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart me-50"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                <span class="add-to-cart">Add to cart</span>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
            <!-- Product Details ends -->

        </div>
    </section>
    <!-- app e-commerce details end -->

</div></div>`;
    else return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`loading`;
}
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<${$543d6d2a56ed7d8d$var$App} />`, document.body);


//# sourceMappingURL=index.d3a92cca.js.map
